import { createInvoiceSaveQueue, mergeSavedInvoiceJson, invoiceSaveErrorKey } from '../utils/invoice-save';
import { matterRuleSaveErrorKey } from '../utils/matter-rule-errors';
import { expenseAmountLockReason } from '../utils/expense-amount-correction';
import ExpenseItemFields from './expense-item-fields';
import AddInvoiceExpenseModal from './add-invoice-expense-modal/add-invoice-expense-modal';
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Modal from './modal';
import FormTextField from './form-textfield';
import FormSelectUser from './form-select-user';
import CurrencySelect from './currency-select';
import Utils, {toNumber} from '../utils/utils';
import withRouter from '../components/withRouter';
import PDFVisualizer from './pdf-visualizer.jsx';
import {
  buildAttachmentGroupLabels,
  buildAttachmentsListUrl,
  resolveAttachmentsCount,
} from '../utils/attachments';
import LockWrapper from '../utils/wrapper/lock-wrapper';
import closeIcon2 from '../assets/img/icon-close2.svg';
import { cachedFetch } from '../utils/cached-api-wrapper';
import { findExactMatterSearchHit } from '../utils/matter-search';
import { resolveDefaultTaxCode, resolveTaxedCode } from '../utils/tax-code-resolvers';
import { getLineItemTableTitle } from '../utils/line-item-table-title';
import { duplicateApprovalMessage } from '../utils/expense-duplicate-message';
import { lineDecisionErrorKey } from '../utils/line-decision-error';
import { canRemoveReportLines, reportRefusalMessage } from '../utils/report-lines';
import { canEditReportLine } from '../utils/report-edit-lock';
import { canDecideInvoice, canDecideLine, isAnyOfHead, isCurrentUserAtInvoiceHead } from '../utils/approval-actions';
import { ADERANT_HEADER_REFERENCE_MAXLENGTH } from '../utils/aderant-field-limits';
import { syncLineTaxJurisdiction } from '../utils/line-tax-jurisdiction-sync';
import { cascadeHeaderFieldToLines, applyHeaderFieldsToNewLine } from '../utils/header-line-cascade';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindowClose,
  faPlusSquare,
  faSpinner,
  faSync,
  faAngleLeft,
  faAngleRight,
  faEllipsisH,
  faEye,
  faEyeSlash,
  faLock,
  faExclamationTriangle,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import { downloadFile } from '../utils/file-manager';
import { decodePdfToBlobUrl, revokePdfBlobUrl } from '../utils/pdf-decoder';
import { getCachedInvoiceImageBlob } from '../utils/invoice-image-cache';
import FormTextAreaAutoSaved from './form-text-area-auto-saved';
import CommentsPanel from './comments/CommentsPanel';
import { hasInvoiceCommentIdentity, legacyCommentsText } from '../utils/comments-api';
import Checkmark from './checkmark';
import Closemark from './closemark';
import Checkbox from './checkbox';
import Toggle from './toggle/toggle';
import Select from 'react-select';
import { fetch } from '../utils/api-wrapper';
import SupplierForm from './supplier-form.js';
import ApproversDisplay from './approvers_display';
import AutoCompleteField from './field-auto-complete';
import { expandMatterNumber, formatMatterLabelFromData, formatMatterNumber } from '../utils/matter-display';
import AdditionalFieldsModal from './additional-fields-modal';
import GlAccountPickerModal from './gl-account-picker-modal';
import SegmentRuleField from './segment-rule-field';
import { GL_FACILITY, hasSegmentRules, isBillableLine, lineOfficeChange, lineOfficeValue, segmentLabelKey, withPickedChartRow } from '../utils/gl-segment-rules';
import Tooltip from './tooltip/tooltip';
import AmountsSummaryTooltip from './amount-summary-tooltip/amount-summary-tooltip';
import LineApprovalHistory from './line-approval-history/line-approval-history';
import { lineNumberOf } from '../utils/line-number';
import HoverInfoCard from './hover-card';
import AccessControl from '../utils/access_control';
import TaxCodeSelector from './tax-code-selector.jsx';
import {
  getPartnerErrorsForDisplay,
  hasPartnerErrorsToShow,
  shouldShowPartnerErrorsIcon,
  isInvoiceFinalized,
  shouldResetSupplierDefaultsOnPayeeChange,
} from '../utils/invoice-status';
import {
  getRedactionProcessErrorState,
  getRedactionProcessStartState,
  getRedactionProcessSuccessState,
  isRedactActionDisabled,
  isRedactionSelectionDisabled,
} from '../utils/redaction-process';
import FormAsyncSelect from "./form-async-select";
import LabelizedAsyncSelect from "./labelized-async-select";
import GlSegmentSelect from "./gl-segment-select";
import { withJurisLineItemDescription } from '../utils/juris-line-item-description';
import { withMatterAttorneyDefault } from '../utils/matter-attorney-default';
import {
  buildActivityAdditionalFieldsFilter,
  buildBillableAdditionalFieldsFilter,
  buildGlAdditionalFieldsFilter,
  isGlSegmentActive,
  shouldHideLineWorkDateColumn,
  shouldShowActivityInlineTrigger,
  shouldShowAttorneyFields,
  shouldShowHeaderTransactionDateField,
  shouldShowHeaderGlUnitField,
  shouldShowLineGlUnitColumn,
  shouldUseInvoiceOfficeLabel,
} from '../utils/additional-fields-filter-helpers';
import InvoiceFormItem from './invoice-form-item';
import LogHistory from './log_history';
import PdfImageDisplay from './pdf-image-display';
import {
  expenseUsesDisbursementCode,
} from '../pages/review-expense/utils/contract-expense-json';
import {
  expenseIsNonClientBillable,
  sanitizeNonClientBillableJson,
} from '../pages/review-expense/utils/conditional-fields';
import { computeInvoiceDueDate } from '../utils/invoice-dates';
import { resolveSupplierHeaderDefaults, shouldApplySupplierHeaderDefaults } from '../utils/supplier-header-defaults';
import {
  buildEliteGlSuggestFiltersFromLine,
  getActivityMissingKeys,
  missingRequiredFieldsForLine,
  resolveRequiredFieldsIconAction,
  supportsProactiveRequiredFieldHints,
} from '../utils/invoice-line-required-fields';
import { buildOfficesSearchPath } from '../utils/offices-search';
import { resolveInvoiceBoldFields, resolveInvoiceHiddenFields } from '../utils/invoice-bold-fields';
import { expandLineSplit } from '../utils/expand-line-split';
import { addUpInvoiceTotals, buildLineTaxRequest, mergeLineTaxes, withoutOrphanBcTaxLine } from '../utils/expense-report-taxes';
import { getAderantSplitNoticeKey, getLineSplitBlockedKey, getLineSplitField } from '../utils/line-split-fields';

// XPEN-3225: the shared select style wraps a selected value (`whiteSpace:
// 'normal'`), which is fine in a form field but not in a cost-detail cell —
// "0854 - Medeiros, John T." came out stacked over four lines, and a wrapped
// value lets the column shrink further still. Truncate on one line instead,
// like the Matter and Type cells beside it.
const LINE_SELECT_STYLE = {
  singleValue: (base) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
};

// XPEN-3225: the label is already the house format for a react-select —
// `<code> - <name>`, the same delimiter formatMatterInlineLabel and the sibling
// pickers use — so it stays as it is. All this adds is the tooltip, because the
// cell ellipsizes it the way the Matter cell ellipsizes its own label.
export const formatLineAttorneyOption = (option, meta) => {
  const label = option.label ?? option.value;
  return meta.context === 'value' ? <span title={label}>{label}</span> : label;
};

// 3E stores the DirectGL (non-billable) voucher line description in a
// 512-character column; a longer value overflows the downstream GL tables and
// blocks GL report generation (XPEN-3049). The Elite export caps that column at
// 512 (payee prefix included), and the non-billable line editor hard-limits to
// match — billable matter narratives are a different column and are left alone.
// Sibling of xpens-api EliteAdapter.VOUCHER_DESCRIPTION_MAX_LENGTH (the backend
// is authoritative) — keep both in sync if the 3E column width ever changes.
const ELITE_VOUCHER_DESCRIPTION_MAX_LENGTH = 512;

// XPEN-3609: how many times one line's taxes are asked for while it keeps changing.
const LINE_TAX_ATTEMPTS = 3;

// Editable budget for a non-billable line description: 512 minus the "<PAYEE> - "
// prefix the DirectGL export prepends into the same 3E column. The payee is
// uppercased exactly as the export does (elite_adapter payee_name.upper()), so a
// length-expanding payee (e.g. ß→"SS") can't let the editor accept text the
// export would then truncate. Elite only; returns undefined otherwise (no cap).
export const eliteGlDescriptionBudget = (isElite, payeeName) =>
  isElite
    ? Math.max(0, ELITE_VOUCHER_DESCRIPTION_MAX_LENGTH - ((payeeName || '').toUpperCase().length + 3))
    : undefined;

// An XPENSE line has a receipt to show when it belongs to an expense (checksum),
// unless that expense was added from the invoice editor, which has none (XPEN-3551).
export const lineHasReceipt = (item) => Boolean(item) && 'checksum' in item && !item._added_from_invoice;

// Keep only the identifying last four digits so they can sit directly after the
// card name without inheriting legacy asterisks or spacing from stored values.
const formatCardMask = (mask) => {
  const rawMask = String(mask ?? '').trim();
  if (!rawMask) return '';

  const lastFourDigits = rawMask.replace(/\D/g, '').slice(-4);
  return lastFourDigits.length === 4 ? lastFourDigits : rawMask;
};

// react-select normally truncates the whole label. Split the name from the mask
// so the flexible name can ellipsize while the identifying mask never shrinks.
const formatPaymentBankOption = (option) => {
  const label = String(option?.label ?? option?.name ?? '').trim();
  const mask = formatCardMask(option?.card_masked_number);

  if (!mask) return label;

  const maskDigits = mask.replace(/\D/g, '');
  const trailingMask = maskDigits ? new RegExp(`\\s*(?:\\*\\s*)*${maskDigits}\\s*$`) : null;
  const name = trailingMask ? label.replace(trailingMask, '').trim() : label;

  return (
    <div className='payment-bank-option'>
      {name && <span className='payment-bank-option__name' title={name}>{name} </span>}
      <span className='ml-1 payment-bank-option__mask'>{mask}</span>
    </div>
  );
};

// The most numbers POST /matters/lookup accepts in one call (XPEN-3859).
const MATTER_LOOKUP_BATCH = 200;

export default inject('data')(
  withRouter(
    observer(
      class Invoice extends Component {
        constructor(props) {
          super(props);

          this.id = this.props.id;
          // Bumped every time loadAttachmentsCount runs or a request is
          // abandoned (getNextInvoice) so an attachments-count response can
          // never overwrite a fresher request's result, regardless of
          // arrival order.
          this.attachmentsRequestGeneration = 0;

          this.styleSelect = {
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: '0 !important',
              boxShadow: state.isFocused ? '0px 0px 10px #F39800 ' : '0 !important',
            }),
          };

          // The Aderant FormAsyncSelect rows sit alongside FormTextField rows
          // that wear .field-unselected { padding: 0 }. react-select's default
          // 2px margin on placeholder / singleValue would push the dropdown
          // text 2px right of the text-input rows — this scoped override
          // zeroes that offset for the three Aderant dropdowns only.
          this.aderantSelectStyles = {
            placeholder: (base) => ({ ...base, marginLeft: 0, marginRight: 0 }),
            singleValue: (base) => ({ ...base, marginLeft: 0, marginRight: 0 }),
          };

          this.state = {
            invoices: this.props.invoices,
            invoice: null,
            confirmDelete: false,
            saving: false,
            status: '',
            previousStatus: '',
            wasModified: false,
            confirmDeleteViewId: null,
            confirmDeleteItems: null,
            savingError: null,
            // XPEN-3579: the Aderant split warning, { viewId, text }, for the line it was loaded for.
            lineSplitNotice: null,
            currentView: 'data',
            pdfBuff: null,
            menuVisible: false,
            showConfirmRestartProcess: false,
            showRequestApproval: false,
            showRequestDetailApproval: false,
            showDisapproval: false, 
            showDelegation: false,
            showReturnToApprover: false,
            returnToApproverComment: '',
            showReturnToEmployee: false,
            returnToEmployeeReason: '',
            successMessage: null,
            delegatedApprover: null,
            showConfirmRestartPostProcess: false,
            billablesSelected: [],
            nonBillablesSelected: [],
            askSupplierCodesAvailable: null,
            promptNewSupplier: false,
            taxes: null,
            clearSupplierRecommendation: null,
            validating: false,
            PurchaseAndPayment: false,
            offices: [],
            payment_banks: [],
            showWorkDetailsModal: false,
            pdfView: 'invoice',
            currentPdfView: 'invoice',
            attachmentsCount: 0,
            showConfirmRedactProcess: false,
            redactionProcessing: false,
            lineItemsBuffer: null,
            redactSelection: [],
            xpenseBuffer: null,
            xpensesBufferCache: {},
            xpenseSelection: [],
            showAdditionalFieldsModal: false, showExpenseItemModal: false,
            addExpenseLineBillable: null,
            lineItemsBufferCache: {},
            additionalFieldsFilter: [],
            glPickerEntries: null,
            supplierDetails: null,
            supplierDetailsId: null,
          };

          this.invoiceRoot = React.createRef();
          this.hasCommentDraft = false;
          this.onCommentDraftChange = (hasDraft) => {
            this.hasCommentDraft = hasDraft;
            if (this._isMounted && !hasDraft && this.state.savingError === this.props.data.t.read('error_comments_draft')) {
              this.setState({ savingError: null });
            }
          };
          this.skipNextRedactSelectionFetch = false;
          this.shouldPrefetchRedactedLineItems = false;
          // XPEN-3859: Elite GL suggest lookups, one per distinct filter signature,
          // shared by every line. A pending entry collects the lines waiting on it:
          // the lookups re-run on every componentDidUpdate, and re-posting while a
          // request is in flight multiplied the calls on large invoices.
          this.eliteGlSuggestBySignature = new Map();
          this.matterLookups = new Map();
          this.matterLookupQueue = new Set();

          this.taxcodes = this.props.data.config?.tax_profile?.map((t) => t.code) ?? [];
          this.taxesPercentage = {};
          this.props.data.config?.tax_profile?.forEach((p) => (this.taxesPercentage[p.code] = p.adjusted_rates ?? p.list_rates));

          this.defaultTaxCode = resolveDefaultTaxCode(this.props.data.config?.tax_profile);
          this.defaultTaxedCode = resolveTaxedCode(this.props.data.config?.tax_profile);

          this.keyListener = (evt) => {
            if (evt.key === 'Escape') {
              if (this.state.invoice != null && this.canLeaveCommentDraft() && !this.state.wasModified) {
                this.props.close(false);
              }
            }
          };

          this.commentBackdropListener = (event) => {
            if (!this.hasCommentDraft) return;
            const root = this.invoiceRoot.current;
            const overlay = root?.closest('.overlay');
            if (overlay && overlay.contains(event.target) && !root.contains(event.target)) {
              event.stopPropagation();
              this.canLeaveCommentDraft();
            }
          };
          this._isMounted = false;
        }

        /**
         * Acquire lock after making changes to the invoice
         */
        acquireLockAfterChange() {
          if (this.state.invoice && this.state.invoice.id) {
            fetch('/locks', 'POST', { object_id: this.state.invoice.id }, null);
          }
        }

        /**
         * Get the information of a matter using cache system
         * @param {string} matterId - The ID of the matter
         * @param {Function} callback - Callback function to execute with matter data
         */
        getMatterInfo(matterId, callback, waiterKey = null) {
          if (!matterId) return callback(null);
          // XPEN-3859: Matters are resolved with one exact lookup per batch of
          // lines, not one search per line. waiterKey lets the per-update lookups
          // wait once per line instead of piling up a callback on every update.
          const key = String(matterId);
          let entry = this.matterLookups.get(key);
          if (entry?.done) {
            // A Matter whose lookup and search both failed is never answered,
            // as before XPEN-3859: the line keeps no hint rather than a false one.
            if (callback && !entry.failed) callback(entry.result);
            return;
          }
          if (!entry) {
            entry = { done: false, result: null, waiting: new Map() };
            this.matterLookups.set(key, entry);
            this.matterLookupQueue.add(key);
            if (this.matterLookupQueue.size === 1) setTimeout(() => this.flushMatterLookups(), 0);
          }
          if (callback) entry.waiting.set(waiterKey ?? Symbol('matter-waiter'), callback);
        }

        // Stable across renders, so the field's label effect does not re-run each time.
        resolveMatterValue = (value, callback) => this.getMatterInfo(value, callback);

        settleMatterLookup(key, result, { failed = false } = {}) {
          const entry = this.matterLookups.get(key);
          if (!entry || entry.done) return;
          entry.done = true;
          entry.result = result;
          entry.failed = failed;
          if (this._isMounted && !failed) entry.waiting.forEach((callback) => callback(result));
          entry.waiting.clear();
        }

        // The search resolves a Matter when the lookup cannot: before /matters/lookup
        // is deployed, or when it fails. A no-match resolves to null so the
        // required-fields refresh never hangs; the search also returns look-alike
        // numbers, so only the line's own Matter counts (XPEN-3752).
        searchMatter(key) {
          cachedFetch(`/matters/search/?text=${key}`, 'GET', {}, (response) => {
            this.settleMatterLookup(key, findExactMatterSearchHit(response?.data, key));
          }, () => this.settleMatterLookup(key, null, { failed: true }));
        }

        flushMatterLookups() {
          const keys = [...this.matterLookupQueue];
          this.matterLookupQueue.clear();
          for (let start = 0; start < keys.length; start += MATTER_LOOKUP_BATCH) {
            const batch = keys.slice(start, start + MATTER_LOOKUP_BATCH);
            fetch(
              '/matters/lookup',
              'POST',
              { numbers: batch },
              (response) => batch.forEach((key) => this.settleMatterLookup(key, findExactMatterSearchHit(response?.data, key))),
              // A failed lookup is not a "no Matter" answer: a transient error must not
              // warn every billable line, so each Matter falls back to the search.
              () => batch.forEach((key) => this.searchMatter(key)),
            );
          }
        }

        getGlAccountInfo(glNatural, callback) {
          if (!glNatural) return callback(null);
          cachedFetch(`/gl/nat/search/?text=${encodeURIComponent(glNatural)}`, 'GET', {}, (response) => {
            const match = (response?.data || []).find((row) => row.name === glNatural)
              ?? (response?.data || [])[0];
            callback(match ?? null);
          });
        }

        getCostTypeInfo(costType, callback) {
          if (!costType) return callback(null);
          cachedFetch(`/cost_type/search/?text=${encodeURIComponent(costType)}`, 'GET', {}, (response) => {
            const match = (response?.data || []).find((row) => row.name === costType)
              ?? (response?.data || [])[0];
            callback(match ?? null);
          });
        }

        getOfficeInfo(officeName, callback) {
          if (!officeName) return callback(null);
          const searchData = buildOfficesSearchPath(officeName, this.props.data.id_client);
          cachedFetch(`/offices/${searchData}`, 'GET', {}, (response) => {
            const offices = response?.data?.offices ?? [];
            const match = offices.find((row) => row.name === officeName) ?? offices[0] ?? null;
            callback(match);
          });
        }

        eliteGlSuggestSignature(filters) {
          return JSON.stringify(filters ?? {});
        }

        refreshEliteGlSuggestForLine(item, data) {
          const filters = buildEliteGlSuggestFiltersFromLine(
            item,
            this.state.invoice?.json ?? {},
            data.config,
          );
          const signature = this.eliteGlSuggestSignature(filters);
          const entry = this.eliteGlSuggestBySignature.get(signature);
          if (entry?.done) {
            this.publishMissingRequiredFieldsForLine(item, { glSuggestResult: entry.result });
            return;
          }
          if (entry) {
            entry.waiting.set(item._view_id, item);
            return;
          }

          const pending = { done: false, result: null, waiting: new Map([[item._view_id, item]]) };
          this.eliteGlSuggestBySignature.set(signature, pending);
          // A failure is kept as "no result" too: retrying on every update would
          // bring the request storm back. Reopening the invoice retries.
          const settle = (result) => {
            pending.done = true;
            pending.result = result;
            if (!this._isMounted) return;
            pending.waiting.forEach((waitingItem) => {
              this.publishMissingRequiredFieldsForLine(waitingItem, { glSuggestResult: result });
            });
            pending.waiting.clear();
          };
          fetch(
            '/gl/accounts/suggest/',
            'POST',
            { ...filters, start: 0, page_size: 1 },
            (response) => settle(response?.data ?? null),
            () => settle(null),
          );
        }

        setMissingRequiredFieldsForLine(item, missing) {
          this.setState((prev) => {
            const prevList = (prev.missingRequiredFieldsByViewId || {})[item._view_id] || [];
            const same =
              prevList.length === missing.length
              && prevList.every((k, i) => k === missing[i]);
            if (same) return null;
            return {
              missingRequiredFieldsByViewId: {
                ...(prev.missingRequiredFieldsByViewId || {}),
                [item._view_id]: missing,
              },
            };
          });
        }

        publishMissingRequiredFieldsForLine(item, lookupContext = {}) {
          const invoiceJson = this.state.invoice?.json ?? {};
          const isBillable = this.itemInCostDetail(item);
          const missing = missingRequiredFieldsForLine({
            data: this.props.data,
            item,
            isBillable,
            invoiceJson,
            ...lookupContext,
          });
          this.setMissingRequiredFieldsForLine(item, missing);
        }

        renderRequiredFieldsIcon(item, isBillable) {
          if (!supportsProactiveRequiredFieldHints(this.props.data)) return null;
          // `_view_id` is 0-based; `!0` would skip the first line.
          if (item?._view_id == null) return null;

          const missingByViewId = this.state.missingRequiredFieldsByViewId || {};
          const missingForLine = missingByViewId[item._view_id] || [];
          if (missingForLine.length === 0) return null;

          const targetCode = isBillable ? item.CostType : item.GLNatural;
          if (
            Utils.isExportFormat(this.props.data, 'aderant')
            && !targetCode
          ) {
            return null;
          }

          const iconAction = resolveRequiredFieldsIconAction(
            this.props.data,
            missingForLine,
            { isBillable },
          );
          const isClickable = iconAction.type === 'modal' || iconAction.type === 'gl-picker';

          const openModal = () => {
            if (iconAction.type === 'gl-picker') {
              this.setState({
                glPickerEntries: [{
                  workItem: item,
                  initialFilters: buildEliteGlSuggestFiltersFromLine(
                    item,
                    this.state.invoice?.json ?? {},
                    this.props.data.config,
                  ),
                }],
              });
              return;
            }
            if (iconAction.type === 'modal') {
              this.setState({
                showAdditionalFieldsModal: true,
                workItem: item,
                additionalFieldsFilter: iconAction.filter,
              });
              if (!isBillable) this.loadLineSplitNotice(item);
            }
          };

          const iconWrapperProps = isClickable
            ? {
              role: 'button',
              tabIndex: 0,
              onClick: openModal,
              onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  openModal();
                }
              },
            }
            : {};

          return (
            <div
              {...iconWrapperProps}
              data-testid={`required-fields-icon-wrapper-${item._view_id}`}
              data-required-fields-clickable={isClickable ? 'true' : 'false'}
            >
              <HoverInfoCard
                info={
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className={`text-primary${isClickable ? ' pointer' : ''}`}
                    size={'2x'}
                  />
                }
                position='pos-top-right'
                additionalInfo={
                  <div style={{ minWidth: '200px', textTransform: 'none' }}>
                    <strong className='mr-2'>
                      {this.props.data.t.read('invoice.missing_required_fields')}
                    </strong>
                    <ul className='mb-0 mt-2 pl-3'>
                      {missingForLine.map((key) => (
                        <li key={key}>{this.props.data.t.read(key)}</li>
                      ))}
                    </ul>
                    {isClickable && (
                      <p className='mb-0 mt-2 italic'>
                        {this.props.data.t.read('click_to')} {this.props.data.t.read('select')}
                      </p>
                    )}
                  </div>
                }
              />
            </div>
          );
        }

        // Called on every componentDidUpdate; cachedFetch's URL cache and
        // the equality-guarded setState below dedupe. A ListItem-identity
        // gate would miss `updateInvoice`'s in-place EmployeeId edits.
        refreshRequiredFieldsLookups() {
          if (!supportsProactiveRequiredFieldHints(this.props.data)) return;
          const items = this.state.invoice?.json?.ListItem ?? [];
          if (!items.length) return;

          items.forEach((item) => {
            if (item?._view_id == null) return;
            const isBillable = this.itemInCostDetail(item);
            const data = this.props.data;

            if (Utils.isExportFormat(data, 'aderant')) {
              const targetCode = isBillable ? item.CostType : item.GLNatural;
              if (!targetCode) return;

              const lookup = isBillable
                ? (cb) => this.getCostTypeInfo(item.CostType, cb)
                : (cb) => this.getGlAccountInfo(item.GLNatural, cb);
              lookup((accountOrType) => {
                const withMatter = (matter) => {
                  this.publishMissingRequiredFieldsForLine(item, { accountOrType, matter });
                };
                if (isBillable && item.MatterId) {
                  this.getMatterInfo(item.MatterId, withMatter, item._view_id);
                } else {
                  withMatter(null);
                }
              });
              return;
            }

            if (Utils.isExportFormat(data, 'surepoint')) {
              this.publishMissingRequiredFieldsForLine(item);
              return;
            }

            if (Utils.isExportFormat(data, 'elite')) {
              if (isBillable) {
                if (!item.MatterId) {
                  this.publishMissingRequiredFieldsForLine(item);
                  return;
                }
                this.getMatterInfo(item.MatterId, (matter) => {
                  this.publishMissingRequiredFieldsForLine(item, { matter });
                }, item._view_id);
                return;
              }

              if (!item.GLNatural) {
                this.publishMissingRequiredFieldsForLine(item);
                return;
              }

              this.refreshEliteGlSuggestForLine(item, data);
              return;
            }

            // XPEN-3620: both Juris products resolve the same line lookups; only
            // Juris Evolution posts an office of its own, so only it looks one up.
            const isJurisEvolution = Utils.isExportFormat(data, 'juris_format');
            if (isJurisEvolution || Utils.isExportFormat(data, 'juris_lexis_nexis')) {
              if (isBillable) {
                this.getCostTypeInfo(item.CostType, (costType) => {
                  const finish = (matter) => {
                    this.publishMissingRequiredFieldsForLine(item, {
                      accountOrType: costType,
                      matter,
                    });
                  };
                  if (item.MatterId) {
                    this.getMatterInfo(item.MatterId, finish, item._view_id);
                  } else {
                    finish(null);
                  }
                });
                return;
              }

              this.getGlAccountInfo(item.GLNatural, (glAccount) => {
                const finish = (officeLookup) => {
                  this.publishMissingRequiredFieldsForLine(item, {
                    accountOrType: glAccount,
                    officeLookup,
                  });
                };
                if (isJurisEvolution && Utils.isEngineType(data, 'legal') && item.Office) {
                  this.getOfficeInfo(item.Office, finish);
                } else {
                  finish(null);
                }
              });
            }
          });
        }

        /**
         * Keep Pay Date aligned with the main supplier terms when Billing Date changes.
         * If terms are missing, we preserve the current Pay Date so the user does not lose data.
         */
        updateInvoiceDateAndDueDate(invoiceDate) {
          const invoice = this.state.invoice;
          const invoiceJson = invoice?.json;

          if (!invoiceJson) {
            this.updateInvoice(invoiceDate, 'json', 'InvoiceDate');
            return;
          }

          const currentSupplierId = invoiceJson.ListSupplier?.[0]?.Index ?? null;

          if (!currentSupplierId) {
            const nextJson = {
              ...invoiceJson,
              InvoiceDate: invoiceDate,
            };

            this.updateInvoice(nextJson, 'json');
            return;
          }

          fetch(
            `/suppliers/${currentSupplierId}`,
            'GET',
            {},
            (response) => {
              const refreshedPaymentTerms = response?.data?.payment_terms;
              const nextJson = {
                ...invoiceJson,
                InvoiceDate: invoiceDate,
                DueDate: computeInvoiceDueDate(invoiceDate, refreshedPaymentTerms) ?? invoiceJson.DueDate,
                ListSupplier: invoiceJson.ListSupplier?.length
                  ? [
                      {
                        ...invoiceJson.ListSupplier[0],
                        payment_terms: refreshedPaymentTerms,
                      },
                      ...invoiceJson.ListSupplier.slice(1),
                    ]
                  : invoiceJson.ListSupplier,
              };

              this.updateInvoice(nextJson, 'json');
            },
            () => {
              const nextJson = {
                ...invoiceJson,
                InvoiceDate: invoiceDate,
              };

              this.updateInvoice(nextJson, 'json');
            }
          );
        }

        /**
         * Compute the taxes from all the items listed in the invoice.
         * Guards on _isMounted so we do not call setState after unmount (avoids React warning and memory leak).
         *
         * XPEN-3609: an expense-report invoice is not sent, since the server would tax each
         * line's Total, tip included. Its header is added up from the lines as they are, and
         * no line's taxes are recalculated here; computeLineTaxes recalculates one line.
         * @param {Function|null} [onError] - Called when the request fails, or when reading its answer
         *   throws (XPEN-3579); none by default, and never on an expense-report invoice.
         */
        computeTaxes(onError = null) {
            if (this.state.invoice?.type === 'XPENSE') {
                this.saveExpenseReportTotals(this.state.invoice.json);
                return;
            }
            const sent = JSON.stringify(this.state.invoice.json);
            fetch('/utils/compute_taxes', 'POST', JSON.parse(sent), (response) => {
                if (!this._isMounted) return;
                // A delayed calculation must not restore an older draft. Recompute
                // from the latest data rather than copying stale fields into it.
                if (JSON.stringify(this.state.invoice.json) !== sent) {
                    this.computeTaxes(onError);
                    return;
                }
                const json = response.data.json;
                const taxes = [json.Tax1, json.Tax2];
                this.setState({taxes: taxes}, () => {
                    if (!this._isMounted) return;
                    this.updateInvoice(json, 'json');
                });
            }, onError)
        }

        saveExpenseReportTotals(json, afterSave = null) {
            const totals = addUpInvoiceTotals(withoutOrphanBcTaxLine(json));
            this.setState({ taxes: [totals.Tax1, totals.Tax2] });
            this.updateInvoice(totals, 'json', null, null, null, afterSave);
        }

        // XPEN-3609: on an expense-report invoice, a line with a receipt behind it keeps the
        // receipt's taxes, and only the header is added up again. Any other line is sent
        // alone, typed so the server taxes its amount before the tip. Its answer is written only onto that line
        // as it was sent (mergeLineTaxes); a line that has changed since is asked again, a
        // few times at most. In every other case (the request cannot be built or fails, the
        // answer holds no such line, lines were added or removed, or the line kept changing)
        // the error is shown, and the header is still added up from the lines as they are.
        computeLineTaxes(viewId, attemptsLeft = LINE_TAX_ATTEMPTS) {
            const line = (this.state.invoice?.json?.ListItem || []).find((item) => item._view_id === viewId);
            if (this.state.invoice?.type !== 'XPENSE' || lineHasReceipt(line)) {
                this.computeTaxes();
                return;
            }
            const showError = () => {
                if (!this._isMounted) return;
                // First: a save clears savingError.
                this.saveExpenseReportTotals(this.state.invoice.json, () => {
                  this.setState({ savingError: this.props.data.t.read('invoice.error_line_tax_recalculation') });
                });
            };
            let request;
            try {
                request = buildLineTaxRequest(this.state.invoice.json, viewId);
            } catch (e) {
                request = null;
            }
            if (!request) {
                showError();
                return;
            }
            fetch('/utils/compute_taxes', 'POST', request.body, (response) => {
                if (!this._isMounted) return;
                const json = this.state.invoice?.json;
                const result = mergeLineTaxes(json, request.sent, response?.data?.json);
                if (result.listItems) {
                    this.saveExpenseReportTotals({ ...json, ListItem: result.listItems });
                } else if (result.reason === 'line_changed' && attemptsLeft > 1) {
                    this.computeLineTaxes(viewId, attemptsLeft - 1);
                } else {
                    showError();
                }
            }, showError);
        }

        computeGrandTotal() {
          const sent = JSON.stringify(this.state.invoice.json);
          fetch('/utils/compute_grand_total', 'POST', JSON.parse(sent), (response) => {
              if (JSON.stringify(this.state.invoice.json) !== sent) { this.computeGrandTotal(); return; }
              const json = response.data.json;
              this.updateInvoice(json, 'json');
          });
        }

        componentDidMount() {
          this._isMounted = true;
          document.addEventListener('keyup', this.keyListener);
          document.addEventListener('click', this.commentBackdropListener, true);

          this.fetchInvoice();
          this.fetchApprover();
          this.refreshOffices();

          if (Utils.userHasPageAccess(this.props.data, "c-card")) {
            this.fetchCards();
          }
          else {
            this.loadBankAcctAP();
          }
        }

        loadAPTypes = (search_query = '', callback = () => {}) => {
          const val = (search_query || '').trim().replace(/\//g, '');
          const filters = val.length > 0 ? [{ id: 'Description', value: val }] : [];
          const searchData = `?field_name=APType&filters=${encodeURIComponent(JSON.stringify(filters))}`;
          cachedFetch(`/client/options/${searchData}`, 'GET', {}, (response) => {
            if (!this._isMounted) return;
            const rows = (response?.data ?? []).map((r) => ({ value: r.Id, label: r.Description }));
            callback(rows.slice(0, 10));
          });
        };

        // XPEN-3225: the roster is held in state rather than rebuilt per call so
        // the option the line carries is the *same object* as the one in the
        // menu. react-select's openMenu picks the option to scroll to with
        // `focusableOptions.indexOf(selectValue[0])` — reference identity — so
        // an equal-but-distinct object opens the menu at the top instead, which
        // is what hid the current choice behind a hundred names.
        //
        // Loaded on the picker's first call rather than at mount: `data.config`
        // is not populated yet when the modal mounts, so a mount-time guard on
        // the exporter never fires.
        attorneyOption = (stored) => {
          const code = typeof stored === 'object' ? stored?.value : stored;
          if (code == null || String(code).trim() === '') return undefined;
          const known = (this.state.attorneyOptions ?? []).find((o) => o.value === code);
          // A code the roster does not carry -- an attorney gone inactive --
          // keeps whatever label it already had rather than falling back to the
          // bare code, which is what LabelizedAsyncSelect did.
          return known ?? (typeof stored === 'object' ? stored : { value: code, label: code });
        };

        // One loader per selected code, memoised so react-select does not see a new
        // `loadOptions` identity on every render.
        attorneyLoaderFor = (stored) => {
          const code = typeof stored === 'object' ? stored?.value : stored;
          const key = code == null ? '' : String(code).trim();
          if (!this._attorneyLoaders) this._attorneyLoaders = new Map();
          if (!this._attorneyLoaders.has(key)) {
            this._attorneyLoaders.set(key, (query, callback) => this.loadAttorneys(query, callback, key));
          }
          return this._attorneyLoaders.get(key);
        };

        loadAttorneys = (search_query = '', callback = () => {}, selectedCode = '') => {
          const val = (search_query || '').trim().replace(/\//g, '');
          // The unfiltered call is what react-select keeps as its
          // `defaultOptions`, and that is the whole menu until the user types,
          // so it carries the roster entire or the selection can fall outside
          // it. The cap stays while filtering.
          const serve = (rows) => {
            const needle = val.toLowerCase();
            if (val) {
              callback(rows.filter((o) => (o.label ?? '').toLowerCase().includes(needle)).slice(0, 10));
              return;
            }
            // The attorney the line already carries goes first, the way the
            // Matter picker opens on the matter it already holds. Ordering is
            // what puts it in front of the user -- it does not depend on
            // react-select resolving the selection against the option list.
            const selected = selectedCode && rows.find((o) => o.value === selectedCode);
            callback(selected ? [selected, ...rows.filter((o) => o !== selected)] : rows);
          };

          if (this.state.attorneyOptions) return serve(this.state.attorneyOptions);

          const searchData = `?field_name=Attorney&filters=${encodeURIComponent('[]')}`;
          cachedFetch(`/client/options/${searchData}`, 'GET', {}, (response) => {
            if (!this._isMounted) return;
            const rows = (response?.data ?? []).map((r) => ({ value: r.Id, label: r.Description }));
            // Every picker on the invoice asks at mount, before any of them has
            // set the state, and cachedFetch hands each subscriber the same
            // response to map for itself. Keeping the first array and serving it
            // to all of them is what makes the identity hold for every line --
            // otherwise the last setState wins and only that one menu opens on
            // its own selection.
            this.setState(
              (previous) => (previous.attorneyOptions ? null : { attorneyOptions: rows }),
              () => serve(this.state.attorneyOptions ?? rows),
            );
          });
        };

        loadJurisdictions = (search_query = '', callback = () => {}) => {
          const val = (search_query || '').trim().replace(/\//g, '');
          const filters = val.length > 0 ? [{ id: 'Description', value: val }] : [];
          const searchData = `?field_name=Jurisdiction&filters=${encodeURIComponent(JSON.stringify(filters))}`;
          cachedFetch(`/client/options/${searchData}`, 'GET', {}, (response) => {
            if (!this._isMounted) return;
            const rows = (response?.data ?? []).map((r) => ({ value: r.Id, label: r.Description }));
            callback(rows.slice(0, 10));
          });
        };

        loadPaymentTerms = (search_query = '', callback = () => {}) => {
          const val = (search_query || '').trim().replace(/\//g, '');
          const filters = val.length > 0 ? [{ id: 'Description', value: val }] : [];
          const searchData = `?field_name=PaymentTerm&filters=${encodeURIComponent(JSON.stringify(filters))}`;
          cachedFetch(`/client/options/${searchData}`, 'GET', {}, (response) => {
            if (!this._isMounted) return;
            const rows = (response?.data ?? []).map((r) => ({ value: r.Id, label: r.Description }));
            callback(rows.slice(0, 10));
          });
        };

        fetchApprover() {
          fetch('/client/users/approvers', 'GET', {}, (response) => {
            if (!this._isMounted) return;
            this.setState({
              users: response.data,
              approver: response.data ? response.data[0] : null,
            });
          });
        }

        componentDidUpdate(prevProps, prevState, snapshot) {
          if (this.state.redactSelection !== prevState.redactSelection) {
            if (this.skipNextRedactSelectionFetch) {
              this.skipNextRedactSelectionFetch = false;
            } else {
              this.fetchLineItems();
            }
          }

          const previousSupplierId = prevState.invoice?.json?.ListSupplier?.[0]?.Index ?? null;
          const currentSupplierId = this.state.invoice?.json?.ListSupplier?.[0]?.Index ?? null;
          if (currentSupplierId !== previousSupplierId) {
            this.fetchSupplierDetails(currentSupplierId);
          }

          const xpensesViewActive =
            this.state.pdfView === 'xpenses' &&
            (this.state.invoice?.type === 'XPENSE' || this.state.invoice?.transaction_type === 'expense_invoice');
          if (xpensesViewActive && this.state.xpenseSelection !== prevState.xpenseSelection) {
            this.fetchExpensePdfs();
          }

          this.refreshRequiredFieldsLookups();
        }

        loadBankAcctAP = () => {
          fetch('/bankacctap/', 'GET', {}, (response) => {
            if (!this._isMounted) return;
            const bankacctap = response?.data?.bankacctap?.map((bank) => ({
              label: bank.description,
              value: bank.key,
              ...bank
            }));
            this.setState({ payment_banks: bankacctap });
          });
        };

        fetchSupplierDetails(supplierId) {
          if (!supplierId) {
            if (this.state.supplierDetails !== null || this.state.supplierDetailsId !== null) {
              this.setState({ supplierDetails: null, supplierDetailsId: null });
            }
            return;
          }

          if (this.state.supplierDetailsId === supplierId && this.state.supplierDetails != null) {
            return;
          }

          this.setState({ supplierDetails: null, supplierDetailsId: supplierId });

          fetch(
            `/suppliers/${supplierId}`,
            'GET',
            {},
            (response) => {
              if (!this._isMounted) return;
              if (this.state.invoice?.json?.ListSupplier?.[0]?.Index !== supplierId) return;

              this.setState({
                supplierDetails: response?.data ?? null,
                supplierDetailsId: supplierId,
              });
            },
            () => {
              if (!this._isMounted) return;
              if (this.state.invoice?.json?.ListSupplier?.[0]?.Index !== supplierId) return;

              this.setState({
                supplierDetails: null,
                supplierDetailsId: supplierId,
              });
            }
          );
        }

        // XPEN-2661: AP type / jurisdiction / payment term are stored as the
        // react-select option object {value,label} so the form shows the
        // description rather than the raw code. The label is resolved from
        // /client/options; when the supplier code has no matching option we fall
        // back to the code as its own label.
        labelizeHeaderIds(json) {
          const fields = [['APTypeId', 'APType'], ['JurisdictionId', 'Jurisdiction'], ['PaymentTermId', 'PaymentTerm']];
          return Promise.all(
            fields.map(([key, field]) => {
              const v = json[key];
              if (v == null || v === '' || typeof v === 'object') return Promise.resolve();
              return this.fetchOptionLabel(field, v).then((opt) => { json[key] = opt; });
            })
          );
        }

        fetchOptionLabel(field_name, id) {
          return new Promise((resolve) => {
            cachedFetch(
              `/client/options/?field_name=${field_name}&filters=${encodeURIComponent('[]')}`,
              'GET',
              {},
              (response) => {
                const row = (response?.data ?? []).find((r) => r.Id === id);
                resolve(row ? { value: row.Id, label: row.Description } : { value: id, label: id });
              }
            );
          });
        }

        fetchCards = () => {
          const filters = [{ id: 'id_client', value: this.props.data.id_client }];
          const searchData = `?filters=${encodeURIComponent(JSON.stringify(filters))}`;

          fetch(
            `/c_card/${searchData}`,
            'GET',
            {},
            (response) => {
              if (!this._isMounted || !response?.data?.c_cards) return;

              const payment_banks = response.data.c_cards.map((card) => ({
                label: card.name,
                value: card._id.$oid,
                ...card
              }));

              this.setState({
                payment_banks: payment_banks,
              });
            },
            () => { },
            false,
            false
          );
        };

        componentWillUnmount() {
          this._isMounted = false;
          document.removeEventListener('keyup', this.keyListener);
          document.removeEventListener('click', this.commentBackdropListener, true);
          if (this.state.pdfBuff) {
            revokePdfBlobUrl(this.state.pdfBuff);
          }
        }
        
        fetchInvoice(onLoaded = null) {
          fetch(
            '/invoices/' + this.id,
            'GET',
            {},
            (response) => {
              if (!this._isMounted) return;
              if (!response.data.invoice.json) {
                response.data.invoice.json = {
                  ListItem: [],
                };
              }

              let itemsList = [];
              response.data.invoice.json.ListItem?.forEach((item, index) => {
                item._view_id = index;
                if ('RedactedItemId' in item) itemsList.push(item.RedactedItemId);
                
                if(this.isItemBillable(item)){
                    if (response.data.invoice.json?.Model === 'CMPA'){
                        const total = item.Total;
                        const rate = toNumber(item.WorkRate);
                        const quantity = toNumber(item.WorkQuantity) === 0 ? rate > 0 ? total / rate : 0 : item.WorkQuantity;
                        const workTotal = toNumber(item.WorkTotal) === 0 ? quantity * rate : item.WorkTotal;
                   
                        item.WorkTotal = workTotal;
                        item.WorkRate = rate;
                        item.WorkQuantity = quantity;
                    }
                }
              });

              let expensesList = [];
              response.data.invoice.json.ListItem?.forEach((item, index) => {
                item._view_id = index;
                if (lineHasReceipt(item)) expensesList.push(item.checksum);
              });

              if (!response.data.invoice.json.ListSupplier) {
                response.data.invoice.json.ListSupplier = [];
              }

              if (this.isXpenseInvoiceForPayload(response.data.invoice)) {
                response.data.invoice.json = sanitizeNonClientBillableJson(response.data.invoice.json);
              }

              const updatedList = this.state.redactSelection.length > 0 ? this.state.redactSelection : itemsList;
              const updatedExpenseList = this.state.xpenseSelection.length > 0 ? this.state.xpenseSelection : expensesList;

              this.setState(
                {
                  invoice: response.data.invoice,
                  redactSelection: updatedList,
                  xpenseSelection: updatedExpenseList,
                  previousStatus: response.data.invoice != null ? response.data.invoice.status : '',
                  images: response.data.images,
                },
                () => {
                  if (this.shouldPrefetchRedactedLineItems) {
                    this.shouldPrefetchRedactedLineItems = false;
                    this.skipNextRedactSelectionFetch = true;
                    this.fetchLineItems(updatedList);
                  }
                  // Opening calculations must read the invoice just installed in state.
                  const inv = this.state.invoice;
                  // XPEN-3797: an exported invoice is never recomputed, so opening it never saves it.
                  if (['Finalizing', 'Finalized'].includes(inv?.status)) this.setState({ taxes: [inv.json?.Tax1, inv.json?.Tax2] });
                  else if (!inv?.json?.Total) this.changeTotal();
                  else if (!inv?.json?.Tax1) this.computeTaxes();
                  else this.setState({ taxes: [inv.json.Tax1, inv.json.Tax2] });
                  onLoaded?.();
                }
              );
              this.loadInvoicePdf(response.data.invoice);
              this.loadAttachmentsCount(response.data.invoice);
            },
            (response) => {
              // invoice not found
              onLoaded?.();
            }
          );
        }

        loadInvoicePdf(invoice) {
          if (!invoice || !invoice.json) {
            if (this.state.pdfBuff) {
              revokePdfBlobUrl(this.state.pdfBuff);
            }
            this.setState({ pdfBuff: null });
            return;
          }

          const fileName =
            invoice.file_name ||
            `${invoice._id || invoice.id}.pdf`;

          if (!fileName) {
            return;
          }

          // XPEN-326: render from the shared image cache so re-opening is instant.
          getCachedInvoiceImageBlob(fileName)
            .then((blob) => {
              if (!this._isMounted) return;
              if (this.state.pdfBuff) {
                revokePdfBlobUrl(this.state.pdfBuff);
              }
              this.setState({ pdfBuff: window.URL.createObjectURL(blob) });
            })
            .catch(() => {
              // Leave the previous buffer in place; the viewer shows its
              // "PDF not available" fallback if there is nothing to display.
            });
        }

        loadAttachmentsCount(invoice) {
          // Bumped unconditionally, before any early return, so every call —
          // including one that decides there is nothing to fetch — invalidates
          // whatever the previous call left in flight.
          this.attachmentsRequestGeneration += 1;

          // PDFVisualizer (and its paperclip) never renders on mobile
          // (invoice.js:2745), so there is nothing to seed a badge for.
          if (this.props.data.isMobile || !invoice || !invoice.json) {
            this.setState({ attachmentsCount: 0 });
            return;
          }

          // A same-invoice refresh (any save/approval action re-runs
          // fetchInvoice) can overlap with an earlier, still in-flight
          // request for the same owner — the generation guard, not owner
          // identity, ensures the most recently *issued* request always wins,
          // regardless of arrival order.
          const requestedGeneration = this.attachmentsRequestGeneration;
          fetch(
            buildAttachmentsListUrl('invoice', this.id),
            'GET',
            {},
            (response) => {
              if (!this._isMounted || requestedGeneration !== this.attachmentsRequestGeneration) return;
              this.setState({ attachmentsCount: resolveAttachmentsCount(response) });
            },
            () => {
              if (!this._isMounted || requestedGeneration !== this.attachmentsRequestGeneration) return;
              this.setState({ attachmentsCount: 0 });
            }
          );
        }

        startRedactProcess() {
          let formData = new FormData();

          // Keep the feedback inside the redactor area instead of blocking the user with the modal.
          this.setState(getRedactionProcessStartState());

          fetch(
            '/invoices/' + this.id + '/redact/process',
            'POST',
            formData,
            (response) => {
              // Acquire lock after successful redact process
              this.acquireLockAfterChange();

              this.setState(getRedactionProcessSuccessState(), () => {
                this.shouldPrefetchRedactedLineItems = true;
                this.fetchInvoice();
              });
            },
            (error) => {
              this.setState(getRedactionProcessErrorState((key) => this.props.data.t.read(key)));
            }
          );
        }

        fetchLineItems(lineItems = [...this.state.redactSelection]) {
          const items = [...lineItems]; // keep local copy
          const sorted = [...items].sort(); // do not mutate state-derived arrays
          const key = JSON.stringify(sorted); // stable, order-independent key

          const formData = new FormData();
          formData.append('items_selection', JSON.stringify(items)); // single stringify

          if (items.length === 0) {
            this.setState({ lineItemsBuffer: null });
            return;
          }

          const cache = this.state.lineItemsBufferCache || {};
          const cached = cache[key];
          if (cached !== undefined) {
            this.setState({ lineItemsBuffer: cached });
            return;
          }

          fetch(`/invoices/${this.id}/redact/merge`, 'POST', formData, (response) => {
            let buf = null;
            const items_pdf = response?.data?.line_items_pdf ?? null;

            if (items_pdf != null) {
              buf = decodePdfToBlobUrl(items_pdf);
            }

            this.setState((prev) => ({
              lineItemsBuffer: buf,
              lineItemsBufferCache: {
                ...(prev.lineItemsBufferCache || {}),
                [key]: buf,
              },
            }));
          });
        }

        fetchExpensePdfs(expenses = [...this.state.xpenseSelection]) {
          const items = [...expenses]; // keep local copy
          const sorted = [...items].sort(); // do not mutate state-derived arrays
          const key = JSON.stringify(sorted); // stable, order-independent key

          const formData = new FormData();
          formData.append('expense_selection', JSON.stringify(items)); // single stringify

          if (items.length === 0) {
            this.setState({ xpenseBuffer: null });
            return;
          }

          const cache = this.state.xpensesBufferCache || {};
          const cached = cache[key];
          if (cached !== undefined) {
            this.setState({ xpenseBuffer: cached });
            return;
          }

          fetch(`/invoices/${this.id}/expenses/merge`, 'POST', formData, (response) => {
            let buf = null;
            const expenses_signed_pdf_url = response?.data?.expenses_signed_pdf_url ?? null;

            if (expenses_signed_pdf_url) {
              buf = expenses_signed_pdf_url;
            }

            this.setState((prev) => ({
              xpenseBuffer: buf,
              xpensesBufferCache: {
                ...(prev.xpensesBufferCache || {}),
                [key]: buf,
              },
            }));
          });
        }

        navigateToExpenseAccount() {
          this.props.navigate(`/expenses_account/${this.state.invoice.id_expense_account}`);
        }

        toggleRedactSelect(id) {
          if (this.state.redactionProcessing) {
            return;
          }

          let sel = [...this.state.redactSelection];
          let new_sel = sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id];
          this.setState({
            redactSelection: new_sel,
          });
        }

        isRedactSelected(id) {
          return this.state.redactSelection.includes(id);
        }

        toggleRedactSelectBulk(ids) {
          if (this.state.redactionProcessing) {
            return;
          }

          let sel = [...this.state.redactSelection];

          const allSelected = ids.every((id) => sel.includes(id));

          let new_sel;
          if (allSelected) {
            // Deselect all
            new_sel = sel.filter((id) => !ids.includes(id));
          } else {
            // Select missing ones
            const selSet = new Set(sel);
            ids.forEach((id) => selSet.add(id));
            new_sel = Array.from(selSet);
          }

          this.setState({
            redactSelection: new_sel,
          });
        }

        areAllRedactSelected(ids) {
          return ids.every((id) => this.state.redactSelection.includes(id));
        }

        toggleXpenseSelect(id) {
          let sel = [...this.state.xpenseSelection];
          let new_sel = sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id];
          this.setState({
            xpenseSelection: new_sel,
          });
        }

        isXpenseSelected(id) {
          return this.state.xpenseSelection.includes(id);
        }

        toggleXpenseSelectBulk(ids) {
          let sel = [...this.state.xpenseSelection];

          const allSelected = ids.every((id) => sel.includes(id));

          let new_sel;
          if (allSelected) {
            // Deselect all
            new_sel = sel.filter((id) => !ids.includes(id));
          } else {
            // Select missing ones
            const selSet = new Set(sel);
            ids.forEach((id) => selSet.add(id));
            new_sel = Array.from(selSet);
          }

          this.setState({
            xpenseSelection: new_sel,
          });
        }

        areAllXpenseSelected(ids) {
          return ids.every((id) => this.state.xpenseSelection.includes(id));
        }

        confirmDelete() {
          this.setState({
            confirmDelete: true,
          });
        }

        // XPEN-3860: an exported expense report is deleted only by a SuperAdmin, once its export is over.
        canDeleteInvoice() {
          const invoice = this.state.invoice;
          if (invoice?.type !== 'XPENSE') return true;
          if (invoice.status === 'Finalizing') return false;
          if (invoice.status === 'Finalized') return (this.props.data.origin_role || this.props.data.role) === 'SuperAdmin';
          return true;
        }

        deleteInvoice() {
          if (!this.canLeaveCommentDraft()) {
            this.setState({ confirmDelete: false });
            return;
          }
          fetch(
            '/invoices/' + this.id,
            'DELETE',
            {},
            (response) => {
              this.props.close(true);
            },
            (error) => {
              const code = error?.response?.data?.error;
              const known = ['expense_account_locked', 'expense_report_action_forbidden'];
              this.setState({
                confirmDelete: false,
                savingError: this.props.data.t.read(known.includes(code) ? `delete_invoice.${code}` : 'internal_saving_error'),
              });
            }
          );
        }

        changeTaxes(value, taxNumber) {
          let taxes = this.state.taxes ?? [];

          taxes[Number(taxNumber[3]) - 1] = value;
          this.setState({ taxes: taxes });
        }

        canLeaveCommentDraft() {
          if (!this.hasCommentDraft) return true;
          this.setState({ savingError: this.props.data.t.read('error_comments_draft') });
          return false;
        }

        requestApproval(approversList) {
          if (!this.canLeaveCommentDraft()) return;
          let formData = new FormData();
          let invoice = this.state.invoice;
          formData.append('approvers', JSON.stringify(approversList));
          formData.append('invoice', JSON.stringify(invoice));
          fetch('/invoices/approvers/' + this?.id, 'POST', formData, (res) => {
            this.setState({
              showRequestApproval: false,
              invoice: null,
            });
            this.fetchInvoice();
            this.props.close(true);
          }, (error) => this.showApprovalRequestError(error));
        }

        showApprovalRequestError(error) {
          this.setState({
            showRequestApproval: false,
            savingError: reportRefusalMessage(error, this.props.data) ?? this.props.data.t.read('internal_saving_error'),
          });
        }

        updateApproversList(approversList) {
          if (!this.canLeaveCommentDraft()) return;
          let formData = new FormData();
          let invoice = this.state.invoice;
          formData.append('approvers', JSON.stringify(approversList));
          formData.append('invoice', JSON.stringify(invoice));

          fetch('/invoices/approvers/' + this?.id, 'PUT', formData, (res) => { }, (error) => this.showApprovalRequestError(error));
        }

        requestDetailApproval(section = this.state.section) {
          if (!this.canLeaveCommentDraft()) return;
          const items = section === 'non-billable' ? this.state.nonBillablesSelected : this.state.billablesSelected;
          const approver = { ...this.state.approver };
          const log =
            Intl.DateTimeFormat(`${this.props.data.t.lang}-US`, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            }).format(new Date()) +
            ' : ' +
            this.props.data.firstName +
            ' ' +
            this.props.data.lastName +
            ' : ' +
            this.props.data.t.read(section === 'non-billable' ? 'invoice.gl_details' : 'invoice.cost_type').toUpperCase() +
            ' : ' +
            this.props.data.t.read('request_approval') +
            ' ' +
            this.props.data.t.read('sent') +
            ' ' +
            this.props.data.t.read('to') +
            ' ' +
            this.state.approver['last_name'] +
            ' ' +
            this.state.approver['first_name'];
          fetch(
            '/invoices/items/request_approval/' + this.id,
            'PUT',
            { approver: approver, items: items, log: log },
            () => {
              // Acquire lock after successful detail approval request
              this.acquireLockAfterChange();

              this.fetchInvoice();
              section === 'non-billable'
                ? this.setState({ nonBillablesSelected: [], showRequestDetailApproval: false })
                : this.setState({ billablesSelected: [], showRequestDetailApproval: false });
            },
            (response) => {
              this.setState({
                savingError:
                  duplicateApprovalMessage(this.props.data, response?.response?.data, 'requester') ||
                  this.props.data.t.read('internal_saving_error'),
                showRequestDetailApproval: false,
              });
            },
            false,
            null
          );
        }

        approveInvoice() {
          if (!this.canLeaveCommentDraft()) return;
          this.setState({ saving: true });
          const invoice = this.state.invoice;

          let formData = new FormData();
          formData.append('invoice', JSON.stringify(invoice));

          fetch('/invoices/approvers/' + this?.id + '/approve', 'POST', formData, (res) => {
            this.setState({
              showRequestApproval: false,
            });
            this.props.close(true);
            this.fetchInvoice();
          });
        }

        disApproveInvoice() {
          if (!this.canLeaveCommentDraft()) return;
          this.setState({ saving: true });
          const invoice = this.state.invoice;
          if (!hasInvoiceCommentIdentity(invoice)) invoice.json.comments = `${Intl.DateTimeFormat(`${this.props.data.t.lang}-US`, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          }).format(new Date())} : ${this.props.data.firstName} ${this.props.data.lastName} : ${this.state.causeDenial}\n${invoice.json.comments ?? ''
            }`;

          let formData = new FormData();
          formData.append('invoice', JSON.stringify(invoice));
          formData.append('cause', this.state.causeDenial);

          fetch('/invoices/approvers/' + this?.id + '/deny', 'POST', formData, (res) => {
            this.setState({
              showRequestApproval: false,
            });
            this.props.close(true);
            this.fetchInvoice();
          });
        }

        /**
         * Delegate current invoice approval to another approver selected in the modal.
         */
        delegateInvoiceApproval() {
          if (!this.canLeaveCommentDraft()) return;
          if (
            !this?.id ||
            !this.state.delegatedApprover ||
            this.state.delegatedApprover?.id_user === this.state.invoice?.json?.approver?.id_user
          ) {
              this.setState({delegateApprover: null, showDelegation: false})
            return;
          }

          const payload = {
            invoice: this.state.invoice,
            approver: this.state.delegatedApprover,
          };

          fetch(`/invoices/approvers/${this?.id}/delegate`, 'POST', payload, () => {
            this.setState({
              showDelegation: false,
              delegatedApprover: null,
            });
            this.props.close(true);
            this.fetchInvoice();
          }, () => {
            this.setState({
              savingError: this.props.data.t.read('internal_saving_error'), 
                showDelegation: false, 
                delegatedApprover: null,
            });
          });
        }

        hasPreviousInvoiceApprover() {
          return (this.state.invoice?.json?.approval_history ?? []).some((entry) => entry?.status === 'approved' && entry?.approver);
        }

        canReturnInvoiceToApprover() {
          return (
            Utils.userHasRole(this.props.data, ['SuperAdmin', 'Admin', 'Manager']) &&
            ['Approved', 'Validated', 'Completed'].includes(this.state.invoice?.status)
          );
        }

        returnInvoiceToApprover() {
          const comment = (this.state.returnToApproverComment || '').trim();
          if (!comment || comment.length > 2000) return;

          fetch(
            `/invoices/approvers/${this?.id}/return`,
            'POST',
            { invoice: this.state.invoice, comment },
            (res) => {
              this.setState({
                showReturnToApprover: false,
                returnToApproverComment: '',
                successMessage: res.data?.message || this.props.data.t.read('return_to_approver_success'),
              });
              this.fetchInvoice();
            },
            (error) => {
              this.setState({
                savingError: this.props.data.t.read(error?.response?.data?.message || 'internal_saving_error'),
                showReturnToApprover: false,
                returnToApproverComment: '',
              });
            }
          );
        }

        // XPEN-3795: a submitted report goes back to its employee as Pending until it is being exported.
        canReturnReportToEmployee() {
          return (
            this.state.invoice?.type === 'XPENSE' &&
            Boolean(this.state.invoice?.id_expense_account) &&
            AccessControl.userCanReturnExpenseReports(this.props.data) &&
            ['Completed', 'Need_Approval', 'Approved', 'Denied', 'Validated'].includes(this.state.invoice?.status)
          );
        }

        returnReportToEmployee() {
          const reason = (this.state.returnToEmployeeReason || '').trim();
          if (!reason || reason.length > 2000) return;

          fetch(
            `/expense_account/${this.state.invoice.id_expense_account}/return`,
            'POST',
            { reason },
            () => {
              this.setState({ showReturnToEmployee: false, returnToEmployeeReason: '' });
              // The report's invoice is gone: back to the list it was opened from.
              this.props.navigate('/dashboard');
            },
            (error) => {
              const code = error?.response?.data?.error;
              const known = ['return_reason_required', 'expense_report_not_returnable', 'expense_account_locked'];
              this.setState({
                savingError: this.props.data.t.read(known.includes(code) ? `return_to_employee.${code}` : 'internal_saving_error'),
                showReturnToEmployee: false,
                returnToEmployeeReason: '',
              });
            }
          );
        }

        // XPEN-3776: the check and cross decide a line through the Approvals page's
        // routes, so the line keeps who decided it and when, the denial reason and
        // its email, under the same permission check.
        decideLineApproval(item, action, causeDenial = null) {
          if (!this.canLeaveCommentDraft()) return;
          if (action === 'deny' && !(causeDenial || '').trim()) {
            this.setState({ savingError: this.props.data.t.read('approval_modal.deny_reason_required') });
            return;
          }
          const lineKey = encodeURIComponent(item.line_id || item._view_id);
          this.setState({ saving: true, savingError: null });
          fetch(
            `/approvals/line-item/${this.id}/${lineKey}/${action}`,
            'POST',
            causeDenial ? { cause: causeDenial.trim() } : {},
            () => {
              this.setState({ saving: false });
              this.fetchInvoice();
            },
            (response) => {
              const refusal = lineDecisionErrorKey(response?.response?.data);
              this.setState({
                saving: false,
                savingError:
                  duplicateApprovalMessage(this.props.data, response?.response?.data, 'approver') ||
                  (refusal ? this.props.data.t.read(refusal) : this.props.data.t.read('internal_saving_error')),
              });
              this.fetchInvoice();
            }
          );
        }

        disApproveDetail(updatedItem, causeDenial) {
          this.decideLineApproval(updatedItem, 'deny', causeDenial);
        }

        applyExpenseAmountsToItem(workItem) {
            // The modal edits amounts_summary; the line item contract stores the
            // pre-tip amount in SubTotal and the amount with tip in Total.
            const subtotal = toNumber(workItem?.amounts_summary?.ItemSubTotal);
            const tip = toNumber(workItem?.amounts_summary?.TipAllocatedToItem);
            workItem.SubTotal = subtotal;
            workItem.TipAllocated = tip;
            workItem.Total = subtotal + tip;
        }

        updateExpenseDetails = (workItem = {...this.state.workItem}) => {
            this.setState({saving: true, expenseDetailsError: null})
            const checksum = workItem.checksum;
            const account_id = this.state.invoice.id_expense_account;

            if (this.state.invoice.transaction_type === 'expense_invoice') {
                this.applyExpenseAmountsToItem(workItem);
                let updatedListItems = this.state.invoice.json.ListItem.map((item) => {
                    return item._view_id === workItem._view_id ? workItem : item;
                })
                this.updateInvoice(updatedListItems, 'json', 'ListItem');
                this.computeTaxes();
                this.fetchInvoice();
                this.setState({ workItem: null, showExpenseItemModal: false });
                return;
            }

            // A line added straight on the invoice with the "+" button has no expense
            // behind it in the expense account, so its checksum is undefined and there
            // is nothing there to sync. Save it as a plain invoice line instead of
            // calling /expenses/<account_id>/undefined/update_items, which 500s.
            if (!checksum) {
                this.applyExpenseAmountsToItem(workItem);
                // Asked once this save has answered: the save still carries the old taxes.
                this.updateInvoice(workItem, 'json', 'ListItem', workItem._view_id, null, () => {
                    this.computeLineTaxes(workItem._view_id);
                });
                this.setState({ workItem: null, showExpenseItemModal: false });
                return;
            }

          // The window's own waiting flag: other saves on this page also toggle `saving`.
          this.setState({ expenseDetailsSaving: true });
          fetch("/expenses/" + account_id + "/" + checksum + "/update_items", "PUT", workItem,
            response => {
              this.fetchInvoice();
              this.setState({ workItem: null, showExpenseItemModal: false, saving: false, expenseDetailsSaving: false });
            },
            error => {
              // Without this the editor stays in `saving`, which locks every field
              // behind lockForFocus/disableForFocus with nothing shown to the user.
              // The refusal shows in the window itself (XPEN-3767): the invoice page is behind it.
              this.setState({
                saving: false,
                expenseDetailsSaving: false,
                expenseDetailsError: this.props.data.t.read(matterRuleSaveErrorKey(error, invoiceSaveErrorKey(error))),
              });
            })
        }

        invoiceSaveQueue = createInvoiceSaveQueue();

        updateInvoice = (value, field, subField, listNo = null, subSubField = null, doneCallback = null) => {
          if (field === 'status' && !this.canLeaveCommentDraft()) return;
          const saveInvoiceId = this.id;
          this.acquireLockAfterChange();

          let invoice = this.state.invoice;
          let savingError = null;
          let fieldUpdateStatus = 4;
          // A line whose Aderant Jurisdiction rewrote its tax code (syncAderantLineTax).
          let lineToRetax = null;

          if (['Tax1', 'Tax2'].includes(subField)) {
            this.changeTaxes(value, subField);
          }

          try {
            if (subField != null) {
              if (listNo === null) {
                if (value === undefined) {
                  delete invoice[field][subField];
                  delete invoice[field][subField + 'Status'];
                } else {
                  invoice[field][subField] = value;
                  invoice[field][subField + 'Status'] = fieldUpdateStatus;
                  cascadeHeaderFieldToLines(invoice[field], subField, this.getInvoiceHiddenFieldIds());
                }
              } else {
                if (subField === 'ListItem') {
                  let tmpNo = -1;

                  invoice.json.ListItem.forEach((item, i) => {
                    if (item._view_id === listNo) {
                      tmpNo = i;
                    }
                  });

                  listNo = tmpNo;
                }

                if (subSubField === null) {
                  invoice[field][subField][listNo] = value;
                } else {
                  if (
                    invoice[field][subField]?.length === 0 ||
                    invoice[field][subField] === undefined ||
                    invoice[field][subField] === null ||
                    invoice[field][subField][listNo] === undefined ||
                    invoice[field][subField][listNo] === null ||
                    invoice[field][subField][listNo] === ''
                  ) {
                    invoice[field][subField] = [{ [subSubField]: value, [subSubField + 'Status']: fieldUpdateStatus }];
                    if (subField === 'ListItem' && this.syncAderantLineTax(invoice[field][subField][0], subSubField, value, fieldUpdateStatus)) {
                      lineToRetax = invoice[field][subField][0];
                    }
                  } else {
                    invoice[field][subField][listNo][subSubField] = value;
                    invoice[field][subField][listNo][subSubField + 'Status'] = fieldUpdateStatus;
                    if (subField === 'ListItem' && this.syncAderantLineTax(invoice[field][subField][listNo], subSubField, value, fieldUpdateStatus)) {
                      lineToRetax = invoice[field][subField][listNo];
                    }
                  }
                }
              }
            } else if (field != null) {
              invoice[field] = value;

              if (invoice[field + 'Status'] != null) {
                invoice[field + 'Status'] = fieldUpdateStatus;
              }
            }
          } catch (e) {
            savingError = this.props.data.t.read('cannot_save_if_not_first_processed');

            this.setState({
              savingError: savingError,
            });
          }

          // XPEN-3609: that line's taxes are asked for once this save has answered, as
          // changeTaxCodeTo does; asked now, a slow save could put the old taxes back.
          if (lineToRetax) {
            const retaxViewId = lineToRetax._view_id;
            const afterSave = doneCallback;
            doneCallback = () => {
              if (afterSave != null) afterSave();
              this.computeLineTaxes(retaxViewId);
            };
          }

          if (savingError === null) {
            this.setState(
              {
                saving: true,
                wasModified: true,
                savingError: savingError,
              },
              () => {
                // Apply edits to the draft immediately, but send one PUT at a time.
                // Pending edits remain in state even if a save fails.
                this.invoiceSaveQueue.enqueue(finish => {
                if (!this._isMounted || this.id !== saveInvoiceId) { finish(false); return; }
                invoice = this.state.invoice;
                let formData = new FormData();
                formData.append('status', invoice.status);
                formData.append('status_details', invoice.status_details == null ? '' : invoice.status_details);

                if (field === 'type') {
                  formData.append('type', value == null ? '' : value);
                }

                if (invoice.json != null) {
                  let json = invoice.json;

                  if (json.ListItem != null) {
                    json = JSON.parse(JSON.stringify(json));
                  }

                  if (this.isXpenseInvoice()) {
                    json = sanitizeNonClientBillableJson(json);
                    invoice.json = json;
                  }

                  formData.append('json', JSON.stringify(json));
                }

                const sentJson = JSON.parse(JSON.stringify(invoice.json));
                fetch(
                  '/invoices/' + saveInvoiceId,
                  'PUT',
                  formData,
                  (response) => {
                    if (!this._isMounted || this.id !== saveInvoiceId) { finish(false); return; }
                    if (response.data?.json) {
                      invoice.json = mergeSavedInvoiceJson(sentJson, this.state.invoice.json, response.data.json);
                    }
                    this.setState(state => ({ commentsRefresh: (state.commentsRefresh || 0) + 1 }));
                    if (invoice.status === 'Pending') {
                      this.props.close(true);

                      if (doneCallback != null) {
                        doneCallback();
                      }
                      finish();
                    } else if (invoice.status === 'Completed') {
                      this.setState(
                        {
                          invoice: invoice,
                          saving: false,
                          confirmDeleteViewId: null,
                          confirmDeleteItems: null,
                        },
                        () => {
                          if (this.state.previousStatus !== invoice.status) {
                            this.fetchInvoice();
                          }

                          if (doneCallback != null) {
                            doneCallback();
                          }
                          finish();
                        }
                      );
                    } else {
                      this.setState(
                        {
                          previousStatus: invoice.status,
                          invoice: invoice,
                          saving: false,
                          showRequestApproval: false,
                          showDisapproval: false,
                          confirmDeleteViewId: null,
                          confirmDeleteItems: null,
                        },
                        () => {
                          if (doneCallback != null) {
                            doneCallback();
                          }
                          finish();
                        }
                      );
                    }
                  },
                  (error) => {
                    if (this._isMounted) this.setState({
                      saving: false,
                      savingError: this.props.data.t.read(invoiceSaveErrorKey(error)),
                      // Dismiss the busy confirmation so the failure is visible.
                      // Keep the edited draft available for correction/retry.
                      confirmDeleteViewId: null,
                      confirmDeleteItems: null,
                    });
                    finish(false);
                  }
                );
                });
              }
            );
          }
        };

        formatAmount(number) {
          let result = this.props.data.t.read('n_a');

          if (number != null && number > 0) {
            result = '$ ' + number.toFixed(2);
          }

          return result;
        }

        formatData(data) {
          if (data == null || data.length === 0) {
            data = this.props.data.t.read('n_a');
          }

          return data;
        }

        deleteItem() {
          let invoice = this.state.invoice;

          for (let i = 0; i < invoice.json.ListItem.length; i++) {
            if (invoice.json.ListItem[i]._view_id === this.state.confirmDeleteViewId) {
              invoice.json.ListItem.splice(i, 1);
              invoice.json.ListItem = invoice.json.ListItem.map((item, index) => ({
                ...item, // Spread the existing properties
                _view_id: index,
              }));
              break;
            }
          }
          // Renumber locally; the tax calculation performs the only save.
          this.computeTaxes();
        }

        confirmRemoveLine(vewId) {
          this.setState({
            confirmDeleteViewId: vewId,
          });
        }

        resolveLineItemDescriptionSource(fieldName, fieldValue, callback) {
          const normalizedFieldValue = fieldValue ?? '';
          if (!Utils.isExportFormat(this.props.data, 'juris_format') || normalizedFieldValue === '') {
            callback(normalizedFieldValue);
            return;
          }

          const searchUrl = fieldName === 'CostType' ? '/cost_type/search/' : '/gl/nat/search/';
          cachedFetch(
            `${searchUrl}?text=${encodeURIComponent(normalizedFieldValue)}`,
            'GET',
            {},
            (response) => {
              const options = Array.isArray(response?.data) ? response.data : [];
              const exactMatch = options.find((option) => option?.name === normalizedFieldValue);
              callback(exactMatch ?? options[0] ?? normalizedFieldValue);
            },
            () => callback(normalizedFieldValue),
            false,
            null,
            { cacheType: 'autocomplete' }
          );
        }

        resolveLineItemDescriptionSourcePromise(fieldName, fieldValue) {
          return new Promise((resolve) => {
            this.resolveLineItemDescriptionSource(fieldName, fieldValue, (descriptionSource) => resolve(descriptionSource));
          });
        }

        getInvoiceHiddenFieldIds() {
          return resolveInvoiceHiddenFields(AccessControl.getViewValue(this.props.data, 'invoice_editor'));
        }

        addItem(billable = false) {
          if (this.addsLinesThroughExpenseForm()) {
            this.setState({ addExpenseLineBillable: Boolean(billable) });
            return;
          }
          let invoice = this.state.invoice;

          if (!invoice.json.ListItem) {
            invoice.json.ListItem = [];
          }
          const item = {
            IsBillable: billable ? 1 : 0,
            Description: '',
            GLOffice: invoice.json?.GLOffice ?? invoice.json?.Office ?? '',
            Office: invoice.json?.Office ?? '',
            GLUnit: invoice.json?.GLUnit ?? '',
            GLNatural: invoice.json?.GLNatural ?? '',
            CostType: invoice.json?.CostType ?? '',
            MatterId: invoice.json?.MatterId ?? '',
            WorkDate: invoice.json?.InvoiceDate,
            _view_id: invoice.json.ListItem.length,
            Total: 0,
          };
          if (this.isXpenseInvoice()) {
            item.ExpenseType = billable ? 'client' : 'internal';
          }
          const descriptionFieldName = billable ? 'CostType' : 'GLNatural';
          const descriptionFieldValue = item[descriptionFieldName];
          this.resolveLineItemDescriptionSource(descriptionFieldName, descriptionFieldValue, (descriptionSource) => {
            const itemWithDescription = withJurisLineItemDescription({
              isJurisFormat: Utils.isExportFormat(this.props.data, 'juris_format'),
              supplierName: this.state.invoice?.json?.ListSupplier?.[0]?.Name,
              item,
              fieldName: descriptionFieldName,
              fieldValue: descriptionFieldValue,
              descriptionSource,
            });

            invoice.json.ListItem.push(applyHeaderFieldsToNewLine(invoice.json, itemWithDescription, this.getInvoiceHiddenFieldIds()));
            this.updateInvoice();
          });
        }

        updateLineItemAndDescription(lineViewId, fieldName, fieldValue, descriptionSource) {
          const listItems = this.state.invoice?.json?.ListItem ?? [];
          const currentItem = listItems.find((it) => it._view_id === lineViewId);

          if (!currentItem) {
            this.updateInvoice(fieldValue, 'json', 'ListItem', lineViewId, fieldName);
            return;
          }

          const updatedItem = withJurisLineItemDescription({
            isJurisFormat: Utils.isExportFormat(this.props.data, 'juris_format'),
            supplierName: this.state.invoice?.json?.ListSupplier?.[0]?.Name,
            item: currentItem,
            fieldName,
            fieldValue,
            descriptionSource,
          });

          this.updateInvoice(updatedItem, 'json', 'ListItem', lineViewId);
        }

        // XPEN-3225: `val` is the whole matter row when the user picks a
        // suggestion and a bare number when they type one and blur, so the
        // Attorney only defaults on the pick — a typed number carries no
        // matter to read it from.
        updateLineMatter(item, val) {
          const matter = val && typeof val === 'object' ? val : null;
          const updatedItem = withMatterAttorneyDefault({
            item,
            matterId: matter?.name ?? val,
            matter,
            showAttorney: shouldShowAttorneyFields(this.props.data),
          });

          this.updateInvoice(updatedItem, 'json', 'ListItem', item._view_id);
        }

        changePdfView = (view) => {
          this.setState(
            {
              pdfView: view,
            },
            () => {
              const xpensesViewActive =
                view === 'xpenses' &&
                (this.state.invoice?.type === 'XPENSE' || this.state.invoice?.transaction_type === 'expense_invoice');
              if (xpensesViewActive) {
                this.fetchExpensePdfs();
              }
            }
          );
        };
        changeView(view) {
          if (view !== this.state.currentView && !this.canLeaveCommentDraft()) return;
          this.setState({
            currentView: view,
          });
        }

        toggleSelectAll(checkbox, sectionName) {
          setTimeout(() => {
            if (sectionName === 'non-billable') {
              this.setState({
                nonBillablesSelected:
                  this.state.invoice.json.ListItem &&
                    this.state.invoice.json.ListItem.filter((item) => this.itemInGlDetail(item)).length !== this.state.nonBillablesSelected.length
                    ? this.state.invoice.json.ListItem.filter((item) => this.itemInGlDetail(item))
                    : [],
              });
            } else {
              this.setState({
                billablesSelected:
                  this.state.invoice.json.ListItem &&
                    this.state.invoice.json.ListItem.filter((item) => this.itemInCostDetail(item)).length !== this.state.billablesSelected.length
                    ? this.state.invoice.json.ListItem.filter((item) => this.itemInCostDetail(item))
                    : [],
              });
            }
          }, 1);
        }

        toggleItemSelected(section, item) {
          let list = section === 'billable' ? this.state.billablesSelected : this.state.nonBillablesSelected;
          let idx = list.indexOf(item);

          if (idx !== -1) {
            list.splice(idx, 1);
          } else {
            list.push(item);
          }

          if (section === 'billable') {
            this.setState({
              billablesSelected: list,
            });
          } else {
            this.setState({
              nonBillablesSelected: list,
            });
          }
        }

        changeTotal() {
          let invoice = this.state.invoice;
          let total = 0;

          invoice.json.ListItem.forEach((item) => {
            total += item.Total;
          });
          invoice.json.Total = total;
          this.setState({ invoice: invoice });
        }

        validateInvoice() {
          if (!this.canLeaveCommentDraft()) return;
          this.setState({ validating: true, saving: true });
          let formData = new FormData();
          formData.append('json', JSON.stringify(this.state.invoice.json));
          formData.append('taxes', JSON.stringify(this.state.taxes));

          let div = document.getElementById('errorMessages');
          div.innerHTML = '';

          fetch(`/invoices/${this.id}/validate`, 'PUT', formData, (response) => {
            this.setState({ validating: false, saving: false });
            if (response?.data?.errors?.length > 0) {
              // Add error message
              let content = 'Errors : <ul>';
              response?.data?.errors?.slice(0, 3).forEach((error) => {
                content += `<li>${error}</li>`;
              });
              content += '</ul>';
              div.innerHTML = content;
              this.acquireLockAfterChange();
              this.openGlSuggestModalFromValidation(response?.data?.errors_meta);
            } else {
              this.getNextInvoice(true, true);
            }
          },
            (error) => {
              this.setState({ validating: false, saving: false, savingError: error?.data?.error ?? this.props.data.t.read('internal_saving_error') });
            }
          );
        }

        openGlSuggestModalFromValidation(errorsMeta) {
          const lineItems = this.state.invoice?.json?.ListItem || [];
          const entries = (Array.isArray(errorsMeta) ? errorsMeta : [])
            .filter((e) => e?.code === 'gl_combination_not_found' && Number.isInteger(e?.line_index))
            .map((e) => ({ workItem: lineItems[e.line_index], initialFilters: e.filters || null }))
            .filter(({ workItem, initialFilters }) => workItem && initialFilters);
          if (entries.length === 0) {
            return;
          }
          this.setState({
            glPickerEntries: entries,
          });
        }

        /**
         * when getting the next invoice we call ask to remove it from list
         * @param {boolean} remove
         * @param {boolean} forward
         */
        getNextInvoice(remove = true, forward = true) {
          if (!this.canLeaveCommentDraft()) return;
          if (this.state.pdfBuff) {
            revokePdfBlobUrl(this.state.pdfBuff);
          }
          // Bump the generation here too: this abandons the current owner
          // well before fetchInvoice() for the next one even starts, so a
          // still-in-flight response for the invoice we're leaving must be
          // invalidated now, not only once the next loadAttachmentsCount runs.
          this.attachmentsRequestGeneration += 1;
          // Reset attachmentsCount here too: otherwise the previous invoice's
          // count briefly shows on the new one until its own request resolves.
          this.setState({ invoice: null, pdfBuff: null, attachmentsCount: 0 });
          const invoices = [...(this.state.invoices ?? [])];
          let nextIndex;
          const indexCurrentInvoice = invoices.findIndex((invoice) => invoice._id === this.id);

          if (forward === true) {
            if (indexCurrentInvoice + 1 < invoices.length) {
              nextIndex = indexCurrentInvoice + 1;
            } else {
              nextIndex = 0;
            }
          } else if (forward === false) {
            if (indexCurrentInvoice - 1 >= 0) nextIndex = indexCurrentInvoice - 1;
            else nextIndex = invoices.length - 1;
          }

          if (remove === true) {
            invoices.splice(indexCurrentInvoice, 1);
            nextIndex = indexCurrentInvoice;
          }

          this.setState({ invoices: [...invoices] });
          if (invoices.length > nextIndex) {
            this.id = invoices[nextIndex]._id;
            this.fetchInvoice();
          } else this.props.close(true);
        }

        confirmDeleteAction(section) {
          let list = section === 'billable' ? this.state.billablesSelected : this.state.nonBillablesSelected;
          list = list.filter(
            (item) =>
              this.state.invoice.user?.username === this.props.data.username ||
              this.props.data.role !== 'Approver' ||
              item.approver?.username === this.props.data.username
          );
          if (section === 'billable') {
            this.setState({
              confirmDeleteItems: list,
              billablesSelected: [],
            });
          } else {
            this.setState({
              confirmDeleteItems: list,
              nonBillablesSelected: [],
            });
          }
        }

        deleteItems() {
          let invoice = this.state.invoice;

          // A save may have replaced the row objects since selection. Match their
          // permanent identity (or legacy view ID), never an object reference.
          invoice.json.ListItem = invoice.json.ListItem.filter(item =>
            !this.state.confirmDeleteItems.some(selected => selected.line_id
              ? selected.line_id === item.line_id : selected._view_id === item._view_id));

          invoice.json.ListItem.forEach((item, index) => { item._view_id = index; });
          this.changeTotal();
          this.computeTaxes();
        }

        showStatus(value) {
          return (value != null && value !== '') ||
            this.props.data.config.frontend_invoice == null ||
            !this.props.data.config.frontend_invoice.hide_na_fields
            ? 'flex'
            : 'none';
        }

        isItemBillable(item) {
          return item.IsBillable == null ? this.state.invoice?.json?.IsBillable : item.IsBillable === true || item.IsBillable === 1;
        }

        /** XPEN-2809 — XPENSE invoices route by disbursement rule; others stay IsBillable-only. */
        isXpenseInvoiceForPayload(invoice) {
          return invoice?.type === 'XPENSE' || invoice?.transaction_type === 'expense_invoice';
        }

        isXpenseInvoice() {
          return this.isXpenseInvoiceForPayload(this.state.invoice);
        }

        // XPEN-3551: on an invoice built from an expense report, a new line must come
        // with the expense behind it, so "+" opens the expense form instead of adding
        // a blank line.
        addsLinesThroughExpenseForm() {
          return this.state.invoice?.type === 'XPENSE' && Boolean(this.state.invoice?.id_expense_account);
        }

        // The API refuses new expenses from here on (PO decision, XPEN-3551).
        isExpenseReportLocked() {
          return ['Validated', 'Finalized'].includes(this.state.invoice?.status);
        }

        // XPEN-3579: why this line cannot be split, already translated, or null.
        lineSplitDisabledReason(item) {
          const key = getLineSplitBlockedKey(item, {
            addsLinesThroughExpenseForm: this.addsLinesThroughExpenseForm(),
            expenseReportLocked: this.isExpenseReportLocked(),
            taxDeduction: this.state.invoice?.json?.TaxDeduction,
          });
          return key ? this.props.data.t.read(key) : null;
        }

        // XPEN-3579: split one GL Detail line into one line per row of the pop-up, then
        // recompute the taxes (on an expense report, only its header is added up again:
        // XPEN-3609). The line is read again from the invoice by its _view_id.
        applyLineSplit = (sourceItem, rows) => {
          const json = this.state.invoice?.json;
          const source = (json?.ListItem || []).find((line) => line._view_id === sourceItem?._view_id);
          if (!source || this.lineSplitDisabledReason(source)) return;
          const splitField = getLineSplitField(this.props.data, source);
          if (!splitField) return;
          const result = expandLineSplit({
            listItems: json.ListItem,
            sourceViewId: source._view_id,
            rows,
            splitField,
            taxDeduction: json.TaxDeduction,
          });
          if (!result) return;

          // One save, already carrying each line's own amounts_summary: the expense-report
          // sync adds up the lines that share a checksum, and the copies keep the source's.
          this.updateInvoice(result.listItems, 'json', 'ListItem');
          // Closed as its Close button does: an error shown next would open behind it.
          this.setState({ showAdditionalFieldsModal: false, additionalFieldsFilter: [] });
          // This code does not rebuild amounts_summary from the recomputed taxes (XPEN-3567).
          // On an expense report there is no request, so this error is never shown (XPEN-3609).
          this.computeTaxes(() => {
            if (!this._isMounted) return;
            this.setState({ savingError: this.props.data.t.read('invoice.line_split.error_tax_recalculation') });
          });
        };

        // XPEN-3579: on Aderant, the pop-up warns when the line's GL account does not require
        // an employee. Only the latest request may answer. It is matched by a token rather
        // than by state: a cached lookup can answer at once, before this setState has applied.
        loadLineSplitNotice(item) {
          if (getLineSplitField(this.props.data, item)?.key !== 'aderant') return;
          const request = {};
          this.lineSplitNoticeRequest = request;
          this.setState({ lineSplitNotice: { viewId: item._view_id, text: null } });
          this.getGlAccountInfo(item.GLNatural, (account) => {
            if (!this._isMounted || this.lineSplitNoticeRequest !== request) return;
            const key = getAderantSplitNoticeKey(account);
            this.setState({
              lineSplitNotice: { viewId: item._view_id, text: key ? this.props.data.t.read(key) : null },
            });
          });
        }

        // XPEN-3579: the pop-up's line as it is now in the invoice, found by its _view_id.
        // A save can replace the line objects (the tax recalculation's answer, and the
        // clean-up an expense-report invoice gets before each save), which would leave the
        // pop-up showing an old copy of the line.
        currentWorkItem() {
          const workItem = this.state.workItem;
          if (workItem?._view_id == null) return workItem;
          const lines = this.state.invoice?.json?.ListItem || [];
          return lines.find((line) => line._view_id === workItem._view_id) ?? workItem;
        }

        handleExpenseLineAdded = () => {
          // Keep the editor locked until the reloaded invoice is in state: an autosave
          // of the copy held in memory would drop the new line, and with it the expense.
          this.setState({ addExpenseLineBillable: null, saving: true });
          this.fetchInvoice(() => this.setState({ saving: false }));
        };

        itemInCostDetail(item) {
          if (this.isXpenseInvoice()) {
            return expenseUsesDisbursementCode(this.state.invoice?.json ?? {}, item);
          }
          return this.isItemBillable(item);
        }

        itemInGlDetail(item) {
          return !this.itemInCostDetail(item);
        }

        hasBillableItems() {
          return (
            this.state.invoice.json &&
            this.state.invoice.json.ListItem &&
            this.state.invoice.json.ListItem.filter((item) => this.itemInCostDetail(item)).length > 0
          );
        }

        hasNonBillableItems() {
          return (
            this.state.invoice.json &&
            this.state.invoice.json.ListItem &&
            this.state.invoice.json.ListItem.filter((item) => this.itemInGlDetail(item)).length > 0
          );
        }

        restartProcess() {
          this.updateInvoice('Pending', 'status', null);
        }

        togglePCardWorkflow() {
          this.setPCardWorkflow(this.state.invoice?.type !== 'p-card');
        }

        setPCardWorkflow(enabled) {
          // Save classification and Prepaid together, including legacy mismatches.
          if (this.state.invoice?.json) {
            this.setState(
              {
                invoice: {
                  ...this.state.invoice,
                  json: {
                    ...this.state.invoice.json,
                    PurchaseAndPayment: enabled,
                    PurchaseAndPaymentStatus: 4,
                  },
                },
              },
              () => this.updateInvoice(enabled ? 'p-card' : null, 'type')
            );
            return;
          }

          this.updateInvoice(enabled ? 'p-card' : null, 'type');
        }

        restartPostProcess() {
          let formData = new FormData();

          fetch('/invoices/' + this.id + '/restart-rules', 'POST', formData, (response) => {
            // Acquire lock after successful restart process
            this.acquireLockAfterChange();

            this.setState({ showConfirmRestartPostProcess: false }, () => {
              this.fetchInvoice();
            });
          });
        }

        supplierChosen(supplier, baseSupplierName = null) {
          if (supplier != null) {
            // When the header-defaults merge below will fetch the full supplier
            // detail (Aderant, pre-approval), skip this display-only fetch and let
            // the merge populate supplierDetails — avoids a duplicate /suppliers/{id}.
            const willMergeHeaderDefaults = shouldApplySupplierHeaderDefaults(
              Utils.isExportFormat(this.props.data, 'aderant'),
              this.state.invoice
            );
            if (!willMergeHeaderDefaults) {
              this.fetchSupplierDetails(supplier._id ?? supplier._id?.$oid ?? null);
            }

            fetch('/suppliers/code/' + supplier._id, 'GET', null, (response) => {
              this.state.clearSupplierRecommendation();

              if (response?.data?.code_found != null) {
                const invoice_json = this.state.invoice.json;
                const supplierName = supplier?.names?.[0] ?? supplier?.name ?? '';
                const shouldResetSupplierDefaults = shouldResetSupplierDefaultsOnPayeeChange(this.state.invoice);
                const shouldResetSupplierUnit = shouldResetSupplierDefaults || this.state.invoice.status === 'Approved';
                const currentMainSupplier = invoice_json.ListSupplier?.[0] ?? {};

                invoice_json.ListSupplier = [
                  {
                    ...currentMainSupplier,
                    Number: response.data.code_found,
                    Name: supplier?.names?.[0] ?? supplier.name ?? '',
                    Index: supplier._id,
                    // Only update supplier-driven defaults when invoice is below Need_Approval.
                    GLNatural: shouldResetSupplierDefaults
                      ? [undefined, null, ''].includes(supplier.gl_code)
                        ? invoice_json.GLNatural
                        : supplier.gl_code
                      : currentMainSupplier.GLNatural,
                    CostType: shouldResetSupplierDefaults
                      ? [undefined, null, ''].includes(supplier.cost_type)
                        ? invoice_json.CostType
                        : supplier.cost_type
                      : currentMainSupplier.CostType,
                    IsBillable: shouldResetSupplierDefaults ? supplier.IsBillable : currentMainSupplier.IsBillable,
                    payment_terms: shouldResetSupplierDefaults ? supplier.payment_terms : currentMainSupplier.payment_terms,
                    reference: shouldResetSupplierDefaults ? supplier.reference : currentMainSupplier.reference,
                  },
                  ...invoice_json.ListSupplier?.slice(1),
                ];

                const lineItemsUpdatePromise = shouldResetSupplierDefaults
                  ? Promise.all(
                      (invoice_json.ListItem ?? []).map(async (it) => {
                        const nextGLNatural = [undefined, null, ''].includes(supplier.gl_code) ? (it.GLNatural ?? '') : supplier.gl_code;
                        const nextCostType = [undefined, null, ''].includes(supplier.cost_type) ? (it.CostType ?? '') : supplier.cost_type;
                        let nextIsBillable = supplier.IsBillable ?? this.isItemBillable(it);
                        if (
                          this.isXpenseInvoice()
                          && expenseIsNonClientBillable(invoice_json, { ...it, IsBillable: nextIsBillable })
                        ) {
                          nextIsBillable = 0;
                        }
                        const isBillableItem = nextIsBillable === true || nextIsBillable === 1;
                        const descriptionFieldName = isBillableItem ? 'CostType' : 'GLNatural';
                        const descriptionFieldValue = isBillableItem ? nextCostType : nextGLNatural;
                        const descriptionSource = await this.resolveLineItemDescriptionSourcePromise(descriptionFieldName, descriptionFieldValue);

                        return withJurisLineItemDescription({
                          isJurisFormat: Utils.isExportFormat(this.props.data, 'juris_format'),
                          supplierName,
                          item: {
                            ...it,
                            GLNatural: nextGLNatural,
                            CostType: nextCostType,
                            GLOffice: [undefined, null, ''].includes(supplier.gl_office || supplier.office) ? (it.GLOffice ?? '') : (supplier.gl_office || supplier.office),
                            Office: [undefined, null, ''].includes(supplier.office) ? (it.Office ?? '') : supplier.office,
                            GLUnit: [undefined, null, ''].includes(supplier.nx_unit) ? it.GLUnit : supplier.nx_unit,
                            IsBillable: nextIsBillable,
                          },
                          fieldName: descriptionFieldName,
                          fieldValue: descriptionFieldValue,
                          descriptionSource,
                        });
                      })
                    )
                  : Promise.resolve(
                      shouldResetSupplierUnit && ![undefined, null, ''].includes(supplier.nx_unit)
                        ? (invoice_json.ListItem ?? []).map(it => ({ ...it, GLUnit: supplier.nx_unit }))
                        : invoice_json.ListItem ?? []
                    );

                // XPEN-2661: fetch the supplier detail and merge the Aderant header
                // ids into this same authoritative write. componentDidUpdate can't
                // re-trigger the apply on a manual pick (json is mutated in place, so
                // prev/next ListSupplier share a reference and the Index change is
                // invisible), so the merge must happen here.
                const supplierDetailPromise = willMergeHeaderDefaults
                  ? new Promise((resolve) =>
                      fetch(`/suppliers/${supplier._id}`, 'GET', {}, (r) => resolve(r?.data ?? null), () => resolve(null))
                    )
                  : Promise.resolve(null);

                Promise.all([lineItemsUpdatePromise, supplierDetailPromise]).then(async ([items, supplierDetail]) => {
                //date are always in format YYYY-MM-DD
                if (shouldResetSupplierDefaults) {
                  const supplierDueDate = computeInvoiceDueDate(invoice_json.InvoiceDate, supplier.payment_terms);

                  if (supplierDueDate) {
                    invoice_json.DueDate = supplierDueDate;
                  }

                  invoice_json.GLNatural = [undefined, null, ''].includes(supplier.gl_code) ? invoice_json.GLNatural : supplier.gl_code;
                  invoice_json.CostType = [undefined, null, ''].includes(supplier.cost_type) ? invoice_json.CostType : supplier.cost_type;
                  invoice_json.Office = [undefined, null, ''].includes(supplier.office) ? invoice_json.Office : supplier.office;
                  // Cleared, not kept: the header GLOffice is GLValue-space and the AP
                  // account books from it, so a previous supplier's value would follow.
                  invoice_json.GLOffice = [undefined, null, ''].includes(supplier.gl_office) ? '' : supplier.gl_office;
                  invoice_json.InvoiceRef = [undefined, null, ''].includes(supplier.reference)
                    ? invoice_json.InvoiceRef
                    : supplier.reference;

                  let headerIsBillable = supplier.IsBillable;
                  if (
                    this.isXpenseInvoice()
                    && expenseIsNonClientBillable({ ...invoice_json, IsBillable: headerIsBillable }, null)
                  ) {
                    headerIsBillable = false;
                  }
                  invoice_json.IsBillable = headerIsBillable;

                  if (supplierDetail) {
                    const { json } = resolveSupplierHeaderDefaults(invoice_json, supplierDetail);
                    invoice_json.APTypeId = json.APTypeId;
                    invoice_json.JurisdictionId = json.JurisdictionId;
                    invoice_json.PaymentTermId = json.PaymentTermId;
                    await this.labelizeHeaderIds(invoice_json);
                    // Reuse the detail we already have for the display slot
                    // (payee_category / address) instead of a second request.
                    this.setState({ supplierDetails: supplierDetail, supplierDetailsId: supplier._id });
                  } else if (willMergeHeaderDefaults) {
                    // Detail fetch failed — fall back to the display-only fetch we skipped.
                    this.fetchSupplierDetails(supplier._id ?? supplier._id?.$oid ?? null);
                  }
                }

                if (shouldResetSupplierUnit && supplier.nx_unit) {
                  invoice_json.GLUnit = supplier.nx_unit;
                }

                invoice_json.ListItem = items;
                this.updateInvoice(invoice_json, 'json');
                });
              } else if (response?.data?.codes_available?.length > 0) {
                this.setState({
                  currentSupplier: supplier,
                  chosenSupplierNumber: null,
                  askSupplierCodesAvailable: response.data.codes_available,
                });
              }
            });
          } else {
            this.fetchSupplierDetails(null);
            if (!Utils.clientAllowsSupplierCreate(this.props.data)) {
              // XPEN-3267 — no create path for this tenant. The supplier field
              // hides "add it" and says why, so this only guards a caller that
              // reaches supplierChosen(null) another way.
              this.setState({ promptNewSupplier: false });
              return;
            }
            this.setState({
              promptNewSupplier: true,
              newSupplierName: baseSupplierName,
              newSupplierAltName: '',
              newSupplierZipcode: '',
              newSupplierCountry: null,
              newSupplierCity: null,
              newSupplierState: null,
              newSupplierAddress: null,
              newSupplierOffice: null,
              newSupplierGL: null,
              newSupplierCostType: null,
              newSupplierNumber: '',
              newSupplierBillable: false,
              newSupplierTaxCode: this.defaultTaxedCode,
              newSupplierActive: true,
            });
          }
        }
        
        

        refreshOffices() {
          const sorting = [{ id: 'name', desc: false }];
          const filters = [{ id: 'id_client', value: this.props.data.id_client }];
          const searchData = `?filters=${encodeURIComponent(JSON.stringify(filters ?? []))}&sorting=${encodeURIComponent(
            JSON.stringify(sorting ?? [])
          )}&start=${encodeURIComponent(0)}`;
          fetch(`/offices/${searchData}`, 'GET', {}, (response) => {
            if (!this._isMounted) return;
            this.setState({
              offices: response.data.offices,
            });
          });
        }

        confirmSupplierNumber() {
          let valid = true;

          if (this.state.chosenSupplierNumber != null) {
            let formData = new FormData();

            formData.append('id_supplier', this.state.currentSupplier._id);
            formData.append('code', this.state.chosenSupplierNumber);

            fetch('/supplier-codes', 'post', formData, (response) => {
              this.updateInvoice(this.state.chosenSupplierNumber, 'json', 'ListSupplier', 0, 'Number', () => {
                this.setState({
                  chosenSupplierNumber: null,
                  askSupplierCodesAvailable: null,
                });
              });
            });
          } else {
            valid = false;
          }

          return valid;
        }
        changeTaxCode(e, lineId) {
          let taxCode = e.target.innerText;
          let indexNextCode = this.taxcodes.findIndex((el) => el === taxCode) + 1;
          indexNextCode = indexNextCode >= this.taxcodes.length ? 0 : indexNextCode;

          let newTaxCode = this.taxcodes[indexNextCode];
          this.changeTaxCodeTo(newTaxCode, lineId);
        }

        changeTaxCodeTo(taxCode, lineId) {
          this.updateInvoice(taxCode, 'json', 'ListItem', lineId, 'TaxCode', () => {
            this.computeLineTaxes(lineId);
          });
        }

        // Mirror a line's TaxCode <-> JurisdictionId on Aderant. Returns true when the
        // edit rewrote the tax-driving TaxCode: updateInvoice then recomputes Tax1/Tax2
        // once its save has answered (the forward direction recomputes via
        // changeTaxCodeTo's callback instead).
        syncAderantLineTax(line, subSubField, value, status) {
          if (!Utils.isExportFormat(this.props.data, 'aderant')) return false;
          return syncLineTaxJurisdiction(line, subSubField, value, status);
        }

        getAndFormatStatusDetails() {
          const raw = this.state.invoice?.status_details;
          if (!raw) return null;

          const lines = raw.split('\n');
          const elements = [];
          let buffer = [];
          let listFound = false;

          const flush = () => {
            if (!buffer.length) return;
            listFound = true;
            elements.push(
              <ul key={`ul-${elements.length}`} className='pl-4 mb-2'>
                {buffer.map((item, i) => (
                  <li key={`li-${elements.length}-${i}`}>{item}</li>
                ))}
              </ul>
            );
            buffer = [];
          };

          lines.forEach((line, i) => {
            if (/^\s+\S/.test(line)) {
              buffer.push(line.trim());
            } else {
              flush();
              const trimmed = line.trim();
              if (trimmed) {
                elements.push(
                  <p key={`p-${i}`} className='card-text mb-1'>
                    {line}
                  </p>
                );
              }
            }
          });
          flush();

          if (!listFound) return null;

          return elements;
        }

        render() {
          let supplierName = '';
          let supplierNumber = '';
          let billingDate = '';
          let dueDate = '';
          let invoiceNo = '';
          let invoiceRef = '';
          let currency = '';
          let total = '';
          let totalWithTax = '';
          let glUnit = '';
          let office = '';
          let tax1 = '';
          let tax2 = '';
          let approver = null;
          let glDepartement = '';
          let glSection = '';
          let groupNumber = '';
          let transactionDate = '';
          let supplierPayeeCategory = '';
          let supplierAddress = '';

          if (this.state.taxes != null) {
            tax1 = this.state.taxes[0];
            tax2 = this.state.taxes[1] ?? '';
          }

          if (this.state.invoice != null) {
            supplierName =
              this.state.invoice.json && this.state.invoice.json.ListSupplier && this.state.invoice.json.ListSupplier.length > 0
                ? this.state.invoice.json.ListSupplier[0].Name
                : '';
            supplierNumber =
              this.state.invoice.json && this.state.invoice.json.ListSupplier && this.state.invoice.json.ListSupplier.length > 0
                ? this.state.invoice.json.ListSupplier[0].Number
                : '';
            billingDate = this.state.invoice.json ? this.state.invoice.json.InvoiceDate : '';
            dueDate = this.state.invoice.json ? this.state.invoice.json.DueDate : '';
            invoiceNo = this.state.invoice.json ? this.state.invoice.json.InvoiceNo : '';
            invoiceRef = this.state.invoice.json ? this.state.invoice.json.InvoiceRef : '';
            currency = this.state.invoice.json ? this.state.invoice.json.Currency : '';
            total = this.state.invoice.json && this.state.invoice.json.Total ? this.state.invoice.json.Total.toFixed(2) : '';
            totalWithTax = this.state.invoice.json ? this.state.invoice.json.TotalWithTax : '';
            glUnit = this.state.invoice.json ? this.state.invoice.json.GLUnit : '';
            office = this.state.invoice.json ? this.state.invoice.json.Office : '';
            tax1 =
              this.state.invoice.json && this.state.invoice.json.Tax1 && this.state.invoice.json.Tax1 !== '' ? this.state.invoice.json.Tax1 : tax1;
            tax2 =
              this.state.invoice.json && this.state.invoice.json.Tax2 && this.state.invoice.json.Tax2 !== '' ? this.state.invoice.json.Tax2 : tax2;
            approver = this.state.invoice.json ? (this.state.invoice.json.approver ? this.state.invoice.json.approver : null) : null;
            glDepartement = this.state.invoice.json ? this.state.invoice.json.GLDepartement : '';
            glSection = this.state.invoice.json ? this.state.invoice.json.GLSection : '';
            groupNumber = this.state.invoice.json ? this.state.invoice.json.GroupNumber : '';
            transactionDate = this.state.invoice.json ? this.state.invoice.json.TranDate : '';
          }

          const isAderant = Utils.isExportFormat(this.props.data, 'aderant');
          const isElite = Utils.isExportFormat(this.props.data, 'elite');
          // XPEN-3543: a line with no attorney of its own posts with the header's, so the
          // cell shows that code as its placeholder rather than an empty picker.
          const showAttorney = shouldShowAttorneyFields(this.props.data);
          const headerAttorney = this.state.invoice?.json?.AttorneyId;
          const headerAttorneyCode = typeof headerAttorney === 'object' ? headerAttorney?.value : headerAttorney;
          // The DirectGL export prepends "<PAYEE> - " into the same 512-char 3E
          // column, so a non-billable line's editable budget is 512 minus that
          // prefix. Billable lines carry no prefix and are not limited here.
          const elitePayeeName = this.state.invoice?.json?.ListSupplier?.[0]?.Name || '';
          const eliteGlDescriptionMaxLength = eliteGlDescriptionBudget(isElite, elitePayeeName);
          const holdDate = this.state.invoice?.json?.HoldDate ?? '';
          const discountDate = this.state.invoice?.json?.DiscountDate ?? '';
          const discountAmount = this.state.invoice?.json?.DiscountAmount ?? '';
          supplierPayeeCategory = this.state.supplierDetails?.payee_category ?? '';
          supplierAddress = this.state.supplierDetails?.address ?? '';

          if (tax1 === 0) tax1 = '';
          if (tax2 === 0) tax2 = '';

	          const invoiceViewSettings = AccessControl.getViewValue(this.props.data, "invoice_editor");
	          const isFocusedInvoice = invoiceViewSettings?.variant === "focused";
	          const invoiceBoldFieldIds = resolveInvoiceBoldFields(invoiceViewSettings);
	          const invoiceHiddenFieldIds = resolveInvoiceHiddenFields(invoiceViewSettings);
	          const boldLabelClass = (fieldId, extraClass = '') => (
	            [invoiceBoldFieldIds.includes(fieldId) ? 'font-weight-bold' : '', extraClass].filter(Boolean).join(' ')
	          );
	          const boldValueClass = (fieldId, extraClass = '') => (
	            [invoiceBoldFieldIds.includes(fieldId) ? 'font-weight-bold font-weight-bolder' : '', extraClass].filter(Boolean).join(' ')
	          );
	          const isInvoiceFieldHidden = (fieldId) => invoiceHiddenFieldIds.includes(fieldId);
	          const showInvoiceField = (fieldId, visible = true) => visible && !isInvoiceFieldHidden(fieldId);

	          return (
            <>
              {this.state.invoice != null && (
                <LockWrapper objectId={this.state.invoice.id} data={this.props.data} callback={() => this.fetchInvoice()}>
                  {({ locked }) => {
                    const lockForFocus = (allow) => this.state.saving || locked || (isFocusedInvoice && !allow);
                    const disableForFocus = (allow) => this.state.saving || locked || (isFocusedInvoice && !allow);
                    const finalized = isInvoiceFinalized(this.state.invoice);
                    // XPEN-3786: an expense report's amounts after approval need the correction permission, and stop at Finalized.
                    const expenseAmountLock = this.state.invoice.type === 'XPENSE' ? expenseAmountLockReason(this.props.data, [this.state.invoice.status]) : null;
                    // XPEN-3794: on their submitted report, the employee changes only the denied lines.
                    const deniedLinesOnly = this.state.invoice.report_editable_lines === 'denied';
                    return (
                    <div className='invoice bg-white' ref={this.invoiceRoot} onKeyDown={(event) => {
                      if (event.key === 'Escape' && this.hasCommentDraft) {
                        event.stopPropagation();
                        this.canLeaveCommentDraft();
                      }
                    }}>
                      {deniedLinesOnly && (
                        <div className="alert alert-info m-2" role="status" data-testid="invoice-denied-lines-only">
                          {this.props.data.t.read('report_edit_lock.submitted')}
                        </div>
                      )}
                      {this.state.promptNewSupplier && (
                        <div>
                          <SupplierForm
                            supplier={{ names: [this.state.newSupplierName], TaxCode: this.defaultTaxCode }}
                            cancelSupplierModal={() => this.setState({ promptNewSupplier: false })}
                            setShowSupplierModal={(show) => this.setState({ promptNewSupplier: show })}
                            callerCallback={(supplier) => {
                              this.supplierChosen(supplier, null);
                            }}
                            simplifiedForm={!AccessControl.userHasRole(this.props.data, ["SuperAdmin", "Admin", "Manager"])}
                            origin_invoice_id={this.id}
                          />
                        </div>
                      )}
                      {this.state.savingError != null ? (
                        <Modal title={this.props.data.t.read('error')} okAction={() => this.setState({ savingError: null })} okText={'ok'}>
                          <div className='text-danger'>{this.state.savingError}</div>
                        </Modal>
                      ) : null}
                      {this.state.successMessage != null ? (
                        <Modal title={this.props.data.t.read('success')} okAction={() => this.setState({ successMessage: null })} okText={'ok'}>
                          <div className='text-success'>{this.state.successMessage}</div>
                        </Modal>
                      ) : null}
                      {this.state.showConfirmRestartProcess ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ showConfirmRestartProcess: false })}
                          okAction={() => this.restartProcess()}
                          okText={this.props.data.t.read('yes')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('invoice.restart_processing')} ?
                        </Modal>
                      ) : null}
                        {this.state.showDelegation ? (
                            <Modal
                            overflow={'visible'}
                            invalid={
                              this.state.delegatedApprover === null ||
                              this.state.delegatedApprover?.id_user === this.state.invoice?.json?.approver?.id_user
                            }
                            title={this.props.data.t.read('delegate_approval')}
                            cancelAction={() => this.setState({ showDelegation: false, delegatedApprover: null })}
                            okAction={() => this.delegateInvoiceApproval()}
                            okText={this.props.data.t.read('delegate')}
                            cancelText={this.props.data.t.read('cancel')}
                            >
                                <FormAsyncSelect
                                    className={'border'}
                                  data={this.props.data}
                                  searchUrl={'/client/users/approvers/search'}
                                  placeholder={this.props.data.t.read('approver')}
                                  value={this.state.delegatedApprover}
                                  optionMap={(approver) => {
                                    if (!approver) return null;
                                    return {
                                      value: approver.id_user,
                                      label: `${approver.first_name || ''} ${approver.last_name || ''}`.trim(),
                                      raw: approver,
                                    };
                                  }}
                                  onChange={(option) => {
                                    this.setState({ delegatedApprover: option?.raw ?? null });
                                  }}
                                />
                                
                            </Modal>
                        ) : null
                            
                        }
                      {this.state.showRequestApproval ? (
                        <ApproversDisplay
                          locked={locked}
                          need_approval={this.state.invoice.status === 'Need_Approval'}
                          cancelAction={() => {
                            this.setState({ showRequestApproval: false });
                            this.fetchInvoice();
                          }}
                          requestApproval={(approversList) => this.requestApproval(approversList)}
                          saveApprovers={(approversList) => this.updateApproversList(approversList)}
                          current_approver={this.state.invoice.json.approver}
                          approvers_list={this.state.invoice.json.approvers_list ?? []}
                          users={this.state.users ?? []}
                          approval_history={this.state.invoice.json.approval_history ?? []}
                          data={this.props.data}
                        />
                      ) : null}
                      {this.state.showRequestDetailApproval ? (
                        <Modal
                          overflow='visible'
                          invalid={this.state.approver === null}
                          title={this.props.data.t.read('request_approval')}
                          cancelAction={() => this.setState({ showRequestDetailApproval: false })}
                          okAction={() => this.requestDetailApproval()}
                          okText={this.props.data.t.read('submit')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          <FormSelectUser
                              data={this.props.data}
                            chosenOption={this.state.approver}
                            options={(this.state.users ?? []).filter(Boolean).sort((a, b) => (a['first_name'] + a['last_name'] > b['first_name'] + b['last_name'] ? 1 : -1))}
                            optionChanged={(option) => {
                              this.setState({ approver: option });
                            }}
                          />
                        </Modal>
                      ) : null}
                      {this.state.showDisapproval ? (
                        <Modal
                          overflow='visible'
                          title={this.props.data.t.read('denial_cause_placeholder')}
                          cancelAction={() => this.setState({ showDisapproval: false })}
                          okAction={() => this.disApproveInvoice()}
                          okText={this.props.data.t.read('submit')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          <input className='form-control' type='text' onChange={(e) => this.setState({ causeDenial: e.target.value })} />
                        </Modal>
                      ) : null}
                      {this.state.showReturnToApprover ? (
                        <Modal
                          overflow='visible'
                          invalid={
                            !this.state.returnToApproverComment.trim() ||
                            this.state.returnToApproverComment.trim().length > 2000
                          }
                          title={this.props.data.t.read('return_to_approver')}
                          cancelAction={() => this.setState({ showReturnToApprover: false, returnToApproverComment: '' })}
                          okAction={() => this.returnInvoiceToApprover()}
                          okText={this.props.data.t.read('submit')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          <label>{this.props.data.t.read('return_to_approver_comment')}</label>
                          <textarea
                            className='form-control'
                            maxLength={2000}
                            rows={4}
                            value={this.state.returnToApproverComment}
                            onChange={(e) => this.setState({ returnToApproverComment: e.target.value })}
                          />
                        </Modal>
                      ) : null}
                      {this.state.showReturnToEmployee ? (
                        <Modal
                          overflow='visible'
                          invalid={
                            !this.state.returnToEmployeeReason.trim() ||
                            this.state.returnToEmployeeReason.trim().length > 2000
                          }
                          title={this.props.data.t.read('return_to_employee.title')}
                          cancelAction={() => this.setState({ showReturnToEmployee: false, returnToEmployeeReason: '' })}
                          okAction={() => this.returnReportToEmployee()}
                          okText={this.props.data.t.read('submit')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          <p>{this.props.data.t.read('return_to_employee.explanation')}</p>
                          <label htmlFor='return-to-employee-reason'>{this.props.data.t.read('return_to_employee.reason')}</label>
                          <textarea
                            id='return-to-employee-reason'
                            className='form-control'
                            maxLength={2000}
                            rows={4}
                            value={this.state.returnToEmployeeReason}
                            onChange={(e) => this.setState({ returnToEmployeeReason: e.target.value })}
                          />
                        </Modal>
                      ) : null}
                      {this.state.showConfirmRestartPostProcess ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ showConfirmRestartPostProcess: false })}
                          okAction={() => this.restartPostProcess()}
                          okText={this.props.data.t.read('yes')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('invoice.restart_post_processing')} ?
                        </Modal>
                      ) : null}
                      {this.state.showConfirmRedactProcess ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ showConfirmRedactProcess: false })}
                          okAction={() => this.startRedactProcess()}
                          okText={this.props.data.t.read('yes')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('redaction.begin_line_item_redaction')} ?
                        </Modal>
                      ) : null}
                      {this.state.confirmDeleteViewId != null ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ confirmDeleteViewId: null })}
                          okAction={() => this.deleteItem()}
                          okText={this.props.data.t.read('delete')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('delete')} ?
                        </Modal>
                      ) : null}
                      {this.state.confirmDeleteItems != null ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ confirmDeleteItems: null })}
                          okAction={() => this.deleteItems()}
                          okText={this.props.data.t.read('delete')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('delete')} ?
                        </Modal>
                      ) : null}
                      {this.state.confirmDelete ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ confirmDelete: false })}
                          okAction={() => this.deleteInvoice()}
                          okText={this.props.data.t.read('delete')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          {this.props.data.t.read('delete')} ?
                        </Modal>
                      ) : null}
                      {this.state.askSupplierCodesAvailable != null ? (
                        <Modal
                          title={this.props.data.t.read('confirm')}
                          cancelAction={() => this.setState({ askSupplierCodesAvailable: null })}
                          okAction={() => this.confirmSupplierNumber()}
                          okText={this.props.data.t.read('save')}
                          cancelText={this.props.data.t.read('cancel')}
                        >
                          <p>
                            {this.props.data.t.read('invoice.choose_supplier_number_for') + ' '}
                            <strong>{this.state.currentSupplier.name}</strong>
                          </p>
                          <div>
                            {this.state.askSupplierCodesAvailable.map((sup, idx) => {
                              return (
                                <div key={sup.code}>
                                  <label
                                    onClick={(e) => {
                                      this.setState({ chosenSupplierNumber: sup.code });
                                    }}
                                  >
                                    <input
                                      type='radio'
                                      name='supplier-number-radio'
                                      checked={this.state.chosenSupplierNumber === sup.code}
                                      value={sup.code}
                                      onChange={() => { }}
                                    />
                                    <strong> #{sup.code}</strong> : {sup.desc}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </Modal>
                      ) : null}
                        {this.state.showExpenseItemModal && (
                            <Modal
                                title={this.props.data.t.read('expense_details') || "Expense Details"}
                                width={600}
                                onClose={() => this.setState({ showExpenseItemModal: false, expenseDetailsError: null })}
                                cancelAction={() => this.setState({ showExpenseItemModal: false, expenseDetailsError: null })}
                                cancelText={this.props.data.t.read('close')}
                                okText={this.props.data.t.read('save')}
                                okAction={this.updateExpenseDetails}
                                invalid={!!expenseAmountLock}
                                finishProcessing={this.state.expenseDetailsSaving}
                            >
                                {expenseAmountLock && (
                                    <div className="alert alert-info" role="status" data-testid="expense-amount-lock">
                                        {this.props.data.t.read(`expense_amount_correction.${expenseAmountLock}`)}
                                    </div>
                                )}
                                {this.state.expenseDetailsError && (
                                    <div className="alert alert-danger" role="alert" data-testid="expense-details-error">
                                        {this.state.expenseDetailsError}
                                    </div>
                                )}
                                <ExpenseItemFields
                                    data={this.props.data}
                                    item={this.state.workItem}
                                    onChange={(workItem) => this.setState({workItem})}
                                    taxCodes={this.taxcodes}
                                    invoiceTaxCode={this.state.invoice.json.TaxCode}
                                    defaultTaxCode={this.defaultTaxCode}
                                    amountLocked={lockForFocus(true) || !!expenseAmountLock}
                                    locked={lockForFocus(false) || !!expenseAmountLock}
                                    focused={isFocusedInvoice}
                                />
                            </Modal>
                        )}
                        {this.state.addExpenseLineBillable !== null && (
                            <AddInvoiceExpenseModal
                                invoiceId={this.id}
                                invoice={this.state.invoice}
                                billable={this.state.addExpenseLineBillable}
                                onClose={() => this.setState({ addExpenseLineBillable: null })}
                                onSaved={this.handleExpenseLineAdded}
                            />
                        )}
                      {this.state.showAdditionalFieldsModal && (
                        <Modal
                          title={this.props.data.t.read('invoice.additional_fields')}
                          width={600}
                          centered
                          onClose={() => this.setState({ showAdditionalFieldsModal: false, additionalFieldsFilter: [] })}
                          secondaryAction={() => this.setState({ showAdditionalFieldsModal: false, additionalFieldsFilter: [] })}
                          secondaryText={this.props.data.t.read('close')}
                        >
                          <AdditionalFieldsModal
                            onClose={() => this.setState({ showAdditionalFieldsModal: false, additionalFieldsFilter: [] })}
                            workItem={this.currentWorkItem()}
                            saving={this.state.saving}
                            locked={locked}
                            updateInvoice={this.updateInvoice}
	                            fields={[...this.state.additionalFieldsFilter]}
	                            boldFieldIds={invoiceBoldFieldIds}
	                            hiddenFieldIds={invoiceHiddenFieldIds}
	                            focusMode={isFocusedInvoice}
	                            isCommentsRequired={this.state.invoice?.json?.Model === 'CMPA'}
	                            onApplyLineSplit={this.applyLineSplit}
	                            lineSplitDisabledReason={this.state.workItem ? this.lineSplitDisabledReason(this.currentWorkItem()) : null}
	                            lineSplitNotice={this.state.lineSplitNotice}
	                          />
                        </Modal>
                      )}
                      {this.state.glPickerEntries && this.state.glPickerEntries.length > 0 && (
                        <GlAccountPickerModal
                          entries={this.state.glPickerEntries}
                          onApply={(segmentValues, entry) => {
                            const targetWorkItem = entry?.workItem;
                            if (!targetWorkItem) return;
                            // Whole-item replace — per-field calls would PUT N times per click.
                            const updatedItem = withPickedChartRow(this.props.data, targetWorkItem, segmentValues);
                            this.updateInvoice(updatedItem, 'json', 'ListItem', targetWorkItem._view_id);
                          }}
                          // Behind the applied lines' saves: a save landing after the
                          // validation would write the invoice's previous status back.
                          onValidate={() => this.setState({}, () => this.invoiceSaveQueue.enqueue((finish) => {
                            finish();
                            this.validateInvoice();
                          }))}
                          onClose={() => this.setState({ glPickerEntries: null })}
                        />
                      )}
                        {this.state.pdfBuff !== null && !this.props.data.isMobile && (
                          <PDFVisualizer
                            pdfBuff={this.state.pdfBuff}
                            maxWidth={"45vw"}
                            minWidth={"25vw"}
                            data={this.props.data}
                            downloadFile={downloadFile}
                            confirmDelete={this.canDeleteInvoice() ? () => this.confirmDelete() : null}
                            id={this.id}
                            pdfView={this.state.pdfView}
                            changePdfView={this.changePdfView}
                            ownerType="invoice"
                            ownerId={this.id}
                            attachmentsCount={this.state.attachmentsCount}
                            // XPEN-3118 — checksum → line/amount/detail parts for
                            // XPENSE attachment groups. Panel only groups when the
                            // loaded list has 2+ distinct owner_sub_id values.
                            attachmentGroupLabels={buildAttachmentGroupLabels(
                              this.state.invoice?.json?.ListItem
                            )}
                            lineItemsBuffer={this.state.lineItemsBuffer}
                            redactedAccess={Utils.userHasPageAccess(this.props.data, 'redactor') && this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice'}
                            xpensesView={this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice'}
                            xpensesBuffer={this.state.xpenseBuffer}
                          />
                        )}
                      <div
                        className={this.props.data.isMobile ? 'content-section invoice-editor-content d-flex flex-column mb-5' : 'content-section invoice-editor-content d-flex flex-column'}
                        style={{ minWidth: '35vh', overflowX: 'auto' }}
                      >
                        <div className='d-flex main-tabs no-scrollbar' style={{ maxWidth: '100%', overflowX: 'auto' }}>
                          {this.state.invoices && this.state.invoices.length > 1 && (
                            <div
                              className='pointer icon-box'
                              role='button'
                              aria-label='Previous invoice'
                              onClick={() => this.getNextInvoice(false, false)}
                            >
                              <FontAwesomeIcon icon={faAngleLeft} className='fa-2x pointer' color='#F39800' />
                            </div>
                          )}
                          <div
                            className={'flex-grow-1 p-3 tab-title ' + (this.state.currentView === 'data' ? 'tab-selected' : '')}
                            onClick={() => this.changeView('data')}
                          >
                            {this.props.data.t.read('data')}
                            {locked && <FontAwesomeIcon icon={faLock} className='ml-4' />}
                          </div>
                          <div
                            className={'flex-grow-1 p-3 tab-title ' + (this.state.currentView === 'history' ? 'tab-selected' : '')}
                            onClick={() => this.changeView('history')}
                          >
                            {this.props.data.t.read('history')}
                          </div>
                          <div className='p-3 pointer' onClick={() => { if (this.canLeaveCommentDraft()) this.props.close(this.state.wasModified); }}>
                            <img src={closeIcon2} alt='Close' />
                          </div>
                          {this.state.invoices && this.state.invoices.length > 1 && (
                            <div
                              className='pointer icon-box'
                              role='button'
                              aria-label='Next invoice'
                              onClick={() => this.getNextInvoice(false, true)}
                            >
                              <FontAwesomeIcon icon={faAngleRight} className='fa-2x pointer' color='#F39800' />
                            </div>
                          )}
                        </div>
                        {this.props.data.isMobile && <PdfImageDisplay file={this.state.pdfBuff} isLoading={false} />}
                        <div
                          className='invoice-editor-scroll'
                          style={
                            this.state.currentView === 'history'
                              ? {
                                  display: 'flex',
                                  flexDirection: 'column',
                                  flex: '1 1 auto',
                                  minHeight: 0,
                                  overflow: 'hidden',
                                }
                              : {
                                  overflowY: 'auto',
                                }
                          }
                        >
                        {this.state.currentView === 'data' ? (
                          <div className='d-flex py-4 flex-column justify-content-between'>
                              {/* Keep the invoice header fields in a dedicated two-column grid so both sides stay aligned. */}
                              <div className='invoice-form-items-grid'>
                                  <div className='invoice-form-items-grid__column'>
                                      {/* XPEN-1622: status value cell uses alert-like styling (border + tint + darker text); span so width adapts to content. */}
	                                      <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.status_txt')} labelClassName={boldLabelClass('Status')} show={showInvoiceField('Status')}>
                                          <div className={'col-auto invoice-value invoice-row-status-' + (this.state.invoice?.status ?? '').toLowerCase()}>
                                              <span className='invoice-status-value'>
                                                {this.props.data.t.read('status.' + (this.state.invoice?.status ?? '').toLowerCase())}
                                              </span>
                                          </div>
                                      </InvoiceFormItem>

                                      {this.props.data.config?.supplier_group && (this.state.invoice?.type == null || this.state.invoice?.type === 'p-card') && !isInvoiceFieldHidden('Workflow') && (
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('workflow')} labelClassName={boldLabelClass('Workflow')} show={true}>
                                              <div className='d-flex align-items-center h-100'>
                                                  <Toggle
                                                      id='toggle-workflow-p-card'
                                                      isOn={this.state.invoice?.type === 'p-card'}
                                                      handleToggle={() => this.togglePCardWorkflow()}
                                                      label={this.props.data.t.read(this.state.invoice?.type === 'p-card' ? 'invoice_types.p-card' : 'invoice_types.ap')}
                                                      disabled={disableForFocus(true) || finalized}
                                                      labelInside={true}
                                                  />
                                              </div>
                                          </InvoiceFormItem>
                                      )}

	                                      <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.supplier_name')} labelClassName={boldLabelClass('SupplierName')} show={showInvoiceField('SupplierName')}>
                                              <FormTextField
                                                  passClearRecommendationFunc={(fnc) => this.setState({ clearSupplierRecommendation: fnc })}
                                                  format='data'
                                                  locked={lockForFocus(false) || this.state.invoice.type === 'XPENSE' || finalized}
                                                  value={supplierName}
                                                  validateChange={(val) => this.updateInvoice(val, 'json', 'ListSupplier', 0, 'Name')}
                                                  searchURL='/suppliers/search/'
                                                  searchParams={this.props.data.config?.supplier_group ? { type: this.state.invoice?.type, transaction_type: this.state.invoice?.transaction_type } : null}
                                                  searchOnFocus={true}
                                                  searchCallback={(sup, typedText) => this.supplierChosen(sup, typedText)}
                                                  hideAddOperation={!Utils.clientAllowsSupplierCreate(this.props.data)}
                                                  noAddOperationHint={this.props.data.t.read('supplier_not_found_creation_disabled')}
                                              />
                                      </InvoiceFormItem>

	                                      <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.supplier_number')} labelClassName={boldLabelClass('SupplierNumber')} show={showInvoiceField('SupplierNumber')}>
                                              <FormTextField
                                                  format='data'
                                                  locked={lockForFocus(false) || this.state.invoice.type === 'XPENSE' || finalized}
                                                  value={supplierNumber}
                                                  validateChange={(val) => {
                                                      this.updateInvoice(val, 'json', 'ListSupplier', 0, 'Number');
                                                  }}
                                              />
                                      </InvoiceFormItem>

                                      {isAderant && (
                                          <>
	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={this.props.data.t.read('invoice.ap_type')}
	                                                  labelClassName={boldLabelClass('APType')}
	                                                  show={showInvoiceField('APType')}
	                                              >
                                                  <LabelizedAsyncSelect
                                                      data={this.props.data}
                                                      inputId='ap-type'
                                                      name='APTypeId'
                                                      fieldName='APType'
                                                      isDisabled={disableForFocus(false)}
                                                      value={this.state.invoice?.json?.APTypeId}
                                                      loadOptions={this.loadAPTypes}
                                                      stylesOverride={this.aderantSelectStyles}
                                                      onChange={(choice) => this.updateInvoice(choice ?? undefined, 'json', 'APTypeId')}
                                                      placeholder={this.props.data.t.read('invoice.ap_type')}
                                                  />
                                              </InvoiceFormItem>

	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={this.props.data.t.read('invoice.jurisdiction')}
	                                                  labelClassName={boldLabelClass('InvoiceJurisdiction')}
	                                                  show={showInvoiceField('InvoiceJurisdiction')}
	                                              >
                                                  <LabelizedAsyncSelect
                                                      data={this.props.data}
                                                      inputId='jurisdiction'
                                                      name='JurisdictionId'
                                                      fieldName='Jurisdiction'
                                                      isDisabled={disableForFocus(false)}
                                                      value={this.state.invoice?.json?.JurisdictionId}
                                                      loadOptions={this.loadJurisdictions}
                                                      stylesOverride={this.aderantSelectStyles}
                                                      onChange={(choice) => this.updateInvoice(choice ?? undefined, 'json', 'JurisdictionId')}
                                                      placeholder={this.props.data.t.read('invoice.jurisdiction')}
                                                  />
                                              </InvoiceFormItem>

	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={this.props.data.t.read('invoice.hold_date')}
	                                                  labelClassName={boldLabelClass('InvoiceHoldDate')}
	                                                  show={showInvoiceField('InvoiceHoldDate')}
	                                              >
                                                  <FormTextField
                                                      format='date'
                                                      locked={lockForFocus(false)}
                                                      value={holdDate}
                                                      validateChange={(val) => this.updateInvoice(val ? val : undefined, 'json', 'HoldDate')}
                                                  />
                                              </InvoiceFormItem>

	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={this.props.data.t.read('invoice.discount_date')}
	                                                  labelClassName={boldLabelClass('DiscountDate')}
	                                                  show={showInvoiceField('DiscountDate')}
	                                              >
                                                  <FormTextField
                                                      format='date'
                                                      locked={lockForFocus(false)}
                                                      value={discountDate}
                                                      validateChange={(val) => this.updateInvoice(val ? val : undefined, 'json', 'DiscountDate')}
                                                  />
                                              </InvoiceFormItem>

                                          </>
                                      )}

	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={<span>{this.props.data.t.read('invoice.billing_date')}<span>*</span></span>}
	                                        labelClassName={boldLabelClass('InvoiceDate')}
	                                        show={showInvoiceField('InvoiceDate', this.showStatus(billingDate) === 'flex')}
	                                      >
                                              <FormTextField
                                                  format='date'
                                                  locked={lockForFocus(true)}
                                                  classes={isFocusedInvoice ? "border-highlight-secondary" : ""}
                                                  value={billingDate}
                                                  validateChange={(val) => this.updateInvoiceDateAndDueDate(val)}
                                              />
                                      </InvoiceFormItem>

                                      {isAderant && (
	                                          <InvoiceFormItem
	                                              data={this.props.data}
	                                              label={this.props.data.t.read('invoice.payment_terms')}
	                                              labelClassName={boldLabelClass('PaymentTerm')}
	                                              show={showInvoiceField('PaymentTerm')}
	                                          >
                                              <LabelizedAsyncSelect
                                                  data={this.props.data}
                                                  inputId='payment-terms'
                                                  name='PaymentTermId'
                                                  fieldName='PaymentTerm'
                                                  isDisabled={disableForFocus(false)}
                                                  value={this.state.invoice?.json?.PaymentTermId}
                                                  loadOptions={this.loadPaymentTerms}
                                                  stylesOverride={this.aderantSelectStyles}
                                                  onChange={(choice) => this.updateInvoice(choice ?? undefined, 'json', 'PaymentTermId')}
                                                  placeholder={this.props.data.t.read('invoice.payment_terms')}
                                              />
                                          </InvoiceFormItem>
                                      )}

                                      {!this.props.data.config.frontend_invoice.hide_due_date && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('invoice.pay_date')}
	                                            labelClassName={boldLabelClass('DueDate')}
	                                            show={showInvoiceField('DueDate', this.showStatus(dueDate) === 'flex')}
	                                          >
                                                  <FormTextField
                                                      format='date'
                                                      locked={lockForFocus(false)}
                                                      value={dueDate}
                                                      validateChange={(val) => this.updateInvoice(val, 'json', 'DueDate')}
                                                  />
                                          </InvoiceFormItem>
                                      )}

                                      {shouldShowHeaderTransactionDateField(this.props.data) && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('invoice.transaction_date')}
	                                            labelClassName={boldLabelClass('TranDate')}
	                                            show={showInvoiceField('TranDate', this.showStatus(transactionDate) === 'flex')}
	                                          >
                                                  <FormTextField
                                                      format='date'
                                                      locked={lockForFocus(false)}
                                                      value={transactionDate}
                                                      validateChange={(val) => this.updateInvoice(val, 'json', 'TranDate')}
                                                  />
                                          </InvoiceFormItem>
                                      )}

                                      {showAttorney && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('invoice.attorney')}
	                                            labelClassName={boldLabelClass('InvoiceAttorney')}
	                                            show={showInvoiceField('InvoiceAttorney')}
	                                          >
                                                  <FormAsyncSelect
                                                      data={this.props.data}
                                                      inputId='invoice-attorney'
                                                      name='AttorneyId'
                                                      isDisabled={disableForFocus(false)}
                                                      isClearable
                                                      optionMap={(option) => option}
                                                      seedInputOnFocus={false}
                                                      value={this.attorneyOption(this.state.invoice?.json?.AttorneyId)}
                                                      loadOptions={this.attorneyLoaderFor(this.state.invoice?.json?.AttorneyId)}
                                                      onChange={(choice) => this.updateInvoice(choice ?? undefined, 'json', 'AttorneyId')}
                                                      placeholder={this.props.data.t.read('invoice.attorney')}
                                                  />
                                          </InvoiceFormItem>
                                      )}

	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={this.props.data.t.read('invoice.invoice_number')}
	                                        labelClassName={boldLabelClass('InvoiceNo')}
	                                        show={showInvoiceField('InvoiceNo', this.showStatus(invoiceNo) === 'flex')}
	                                      >
                                              <FormTextField
                                                  format='data'
                                                  locked={lockForFocus(false)}
                                                  value={invoiceNo}
                                                  validateChange={(val) => this.updateInvoice(val, 'json', 'InvoiceNo')}
                                              />
                                      </InvoiceFormItem>
	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={<span>{this.props.data.t.read('invoice.invoice_ref')}<span>*</span></span>}
	                                        labelClassName={boldLabelClass('InvoiceRef')}
	                                        show={showInvoiceField('InvoiceRef', this.showStatus(invoiceRef) === 'flex')}
	                                      >
                                              <FormTextField
                                                  format='data'
                                                  locked={lockForFocus(true)}
                                                  classes={isFocusedInvoice ? "border-highlight-secondary" : ""}
                                                  value={invoiceRef}
                                                  maxLength={isAderant ? ADERANT_HEADER_REFERENCE_MAXLENGTH : undefined}
                                                  validateChange={(val) => this.updateInvoice(val, 'json', 'InvoiceRef')}
                                              />
                                      </InvoiceFormItem>

	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={this.props.data.t.read('invoice.currency')}
	                                        labelClassName={boldLabelClass('Currency')}
	                                        show={showInvoiceField('Currency', this.showStatus(currency) === 'flex')}
	                                      >
                                              <CurrencySelect
                                                  data={this.props.data}
                                                  disabled={lockForFocus(true)}
                                                  value={currency}
                                                  onChange={(code) => this.updateInvoice(code, 'json', 'Currency')}
                                              />
                                      </InvoiceFormItem>

                                      {!this.props.data?.config?.frontend_invoice?.hide_group_number && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('invoice.group_number')}
	                                            labelClassName={boldLabelClass('GroupNumber')}
	                                            show={showInvoiceField('GroupNumber', this.showStatus(groupNumber) === 'flex')}
	                                          >
                                                  <FormTextField
                                                      format='data'
                                                      locked={lockForFocus(false)}
                                                      value={groupNumber}
                                                      validateChange={(val) => this.updateInvoice(val, 'json', 'GroupNumber')}
                                                  />
                                          </InvoiceFormItem>
                                      )}

                                      {isAderant && (
	                                          <InvoiceFormItem
	                                              data={this.props.data}
	                                              label={this.props.data.t.read('invoice.discount_amount')}
	                                              labelClassName={boldLabelClass('DiscountAmount')}
	                                              show={showInvoiceField('DiscountAmount')}
	                                          >
                                              <FormTextField
                                                  format='money'
                                                  locked={lockForFocus(false)}
                                                  value={discountAmount}
                                                  validateChange={(val) => this.updateInvoice(val !== '' && val != null ? val : undefined, 'json', 'DiscountAmount')}
                                              />
                                          </InvoiceFormItem>
                                      )}

	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={this.props.data.t.read('invoice.total')}
	                                        labelClassName={boldLabelClass('Total')}
	                                        show={showInvoiceField('Total', this.showStatus(total) === 'flex')}
	                                      >
                                              <FormTextField
                                                  format='money'
                                                  locked={true}
                                                  value={total}
                                                  validateChange={(val) => {
                                                      this.updateInvoice(val, 'json', 'Total');
                                                      this.computeGrandTotal();
                                                  }}
                                              />
                                      </InvoiceFormItem>

	                                      <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={this.props.data.t.read('invoice.total_with_tax')}
	                                        labelClassName={boldLabelClass('TotalWithTax')}
	                                        show={showInvoiceField('TotalWithTaxTop', this.showStatus(totalWithTax) === 'flex')}
	                                      >
                                              <FormTextField
                                                  format='money'
                                                  locked={true}
                                                  value={totalWithTax}
                                                  validateChange={(val) => this.updateInvoice(val, 'json', 'TotalWithTax')}
                                              />
                                      </InvoiceFormItem>
	                                      {shouldShowHeaderGlUnitField(this.props.data) && <InvoiceFormItem
	                                        data={this.props.data}
	                                        label={this.props.data.t.read(segmentLabelKey(this.props.data.config, 'GLUnit', 'invoice.unit'))}
	                                        labelClassName={boldLabelClass('GLUnit')}
	                                        show={showInvoiceField('GLUnit', this.showStatus(glUnit) === 'flex')}
	                                      >
                                              <FormAsyncSelect
                                                  searchUrl={"/suppliers/unit/search"}
                                                  placeholder={this.props.data.t.read(segmentLabelKey(this.props.data.config, 'GLUnit', 'invoice.unit'))}
                                                  value={glUnit ?? null}
                                                  onChange={(val) => this.updateInvoice(val?.value, 'json', 'GLUnit')}
                                                  isDisabled={disableForFocus(false)}
                                              />
                                      </InvoiceFormItem>}
                                      {
                                          isElite
                                          && isGlSegmentActive(this.props.data, 'GLOffice')
                                          && !this.props.data?.config?.unit_is_office
                                          && (
	                                              <InvoiceFormItem
	                                                data={this.props.data}
	                                                label={this.props.data.t.read('office')}
	                                                className='mb-1'
	                                                labelClassName={boldLabelClass('InvoiceOffice')}
	                                                show={showInvoiceField('InvoiceOffice', this.showStatus(office) === 'flex')}
	                                              >
                                                      <FormAsyncSelect
                                                          searchUrl={"/offices/search"}
                                                          placeholder={this.props.data.t.read('office')}
                                                          value={office ?? null}
                                                          onChange={(val) => this.updateInvoice(val?.value ?? '', 'json', 'Office')}
                                                          isDisabled={disableForFocus(false)}
                                                      />
                                              </InvoiceFormItem>
                                          )}
                                      {isAderant && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('office')}
	                                            className='mb-1'
	                                            labelClassName={boldLabelClass('InvoiceOffice')}
	                                            show={showInvoiceField('InvoiceOffice', this.showStatus(office) === 'flex')}
	                                          >
                                                  <FormAsyncSelect
                                                      searchUrl={"/offices/search"}
                                                      placeholder={this.props.data.t.read('office')}
                                                      value={office ?? null}
                                                      onChange={(val) => this.updateInvoice(val?.value ?? '', 'json', 'Office')}
                                                      isDisabled={disableForFocus(false)}
                                                  />
                                          </InvoiceFormItem>
                                      )}
                                      {!isAderant && isGlSegmentActive(this.props.data, 'GLDepartement') &&
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.gl_departement')} labelClassName={boldLabelClass('InvoiceGLDepartement')} show={showInvoiceField('InvoiceGLDepartement')}>
                                                  <FormTextField
                                                      format='data'
                                                      locked={lockForFocus(false)}
                                                      value={glDepartement}
                                                      validateChange={(val) => this.updateInvoice(val, 'json', 'GLDepartement')}
                                                  />
                                          </InvoiceFormItem>}
                                      {!isAderant && isGlSegmentActive(this.props.data, 'GLSection') &&
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.gl_section')} labelClassName={boldLabelClass('InvoiceGLSection')} show={showInvoiceField('InvoiceGLSection')}>
                                                  <GlSegmentSelect
                                                      segment="GLSection"
                                                      value={glSection}
                                                      onChange={(next) => this.updateInvoice(next, 'json', 'GLSection')}
                                                      isDisabled={lockForFocus(false)}
                                                      name="invoice-gl-section-select"
                                                      placeholder={this.props.data.t.read('invoice.gl_section')}
                                                  />
                                          </InvoiceFormItem>}
                                      {this.state.invoice.type === 'XPENSE' && (
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.type')} labelClassName={boldLabelClass('InvoiceType')} show={showInvoiceField('InvoiceType')}>
                                                  <Tooltip message={this.props.data.t.read('click_to_open_expense_account')}>
                                    <span className={'pointer text-underline text-blue'} onClick={() => this.navigateToExpenseAccount()}>
                                      {this.props.data.t.read('expenses')}
                                    </span>
                                                  </Tooltip>
                                          </InvoiceFormItem>
                                      )}
                                      {this.state.invoice.transaction_type === 'expense_invoice' && (
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.type')} labelClassName={boldLabelClass('InvoiceType')} show={showInvoiceField('InvoiceType')}>
                                  <span>
                                    {this.props.data.t.read('expenses')}
                                  </span>
                                          </InvoiceFormItem>
                                      )}
                                      {Utils.userHasPageAccess(this.props.data, 'approval') && approver !== null && (() => {
                                            const head = (this.state.invoice?.json?.approvers_list ?? [])[0];
                                            const isGroup = isAnyOfHead(head);
                                            if (isGroup) {
                                                const memberNames = head
                                                    .map((m) => `${m.first_name || ''} ${m.last_name || ''}`.trim())
                                                    .filter(Boolean);
                                                return (
                                                    <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.approver')} labelClassName={boldLabelClass('Approver')} show={showInvoiceField('Approver')}>
                                                        <div title={`${this.props.data.t.read('invoice.approver_any_of_prefix')} ${memberNames.join(', ')}`}>
                                                            <span className='badge badge-info mr-2 font-weight-bold'>{this.props.data.t.read('invoice.approver_any_of_prefix')}</span>
                                                            {memberNames.map((name, i) => (
                                                                <span key={i} className='badge badge-light border mr-1 mb-1'>{name}</span>
                                                            ))}
                                                        </div>
                                                    </InvoiceFormItem>
                                                );
                                            }
                                            const displayValue = `${approver.first_name || ''} ${approver.last_name || ''}`.trim();
                                            return (
                                                <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.approver')} labelClassName={boldLabelClass('Approver')} show={showInvoiceField('Approver')}>
                                                    <FormTextField format='data' locked={true} value={displayValue} />
                                                </InvoiceFormItem>
                                            );
                                      })()}
                                  </div>
                                  <div className='invoice-form-items-grid__column'>
                                      {/* Reserve the first grid row on the right side so its first field starts lower. */}
                                      <div className='invoice-form-items-grid__spacer' aria-hidden='true' />
                                      
                                      {['juris', 'demo'].includes(this.props.data.config?.engine) && (
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('achat_and_payment')} className='invoice-form-item--compact' labelClassName={boldLabelClass('PurchaseAndPayment')} show={showInvoiceField('PurchaseAndPayment')}>
                                                  <Checkbox
                                                      isChecked={this.state.invoice?.json?.PurchaseAndPayment ?? false}
                                                      onChange={(enabled) => {
                                                          const invoice = this.state.invoice;
                                                          // Expense receipts keep their existing classification.
                                                          if ([null, undefined, '', 'invoice', 'p-card'].includes(invoice?.type) && invoice?.transaction_type !== 'expense_invoice') {
                                                              this.setPCardWorkflow(enabled);
                                                          } else {
                                                              this.updateInvoice(enabled, 'json', 'PurchaseAndPayment');
                                                          }
                                                      }}
                                                      disabled={disableForFocus(false)}
                                                  />
                                          </InvoiceFormItem>
                                      )}
                                      {this.state.invoice?.json?.PurchaseAndPayment && this.props.data.config?.payment_modes && (
	                                          <InvoiceFormItem
	                                            data={this.props.data}
	                                            label={this.props.data.t.read('payment_mode')}
	                                            className='invoice-form-item--compact mb-1'
	                                            labelClassName={boldLabelClass('PaymentMode')}
	                                            show={showInvoiceField('PaymentMode')}
	                                          >
                                                      <Select
                                                          isDisabled={disableForFocus(false)}
                                                          name='payment_mode'
                                                          value={this.state.invoice.json?.PaymentMode || null}
                                                          options={
                                                              this.props.data.config.payment_modes
                                                                  ? this.props.data.config.payment_modes.map((p) => ({ value: p.id, label: p.name }))
                                                                  : []
                                                          }
                                                          styles={this.styleSelect}
                                                          classNamePrefix='select'
                                                          onChange={(choice) => this.updateInvoice(choice, 'json', 'PaymentMode')}
                                                      />
                                          </InvoiceFormItem>
                                      )}
                                      {this.state.invoice?.json?.PurchaseAndPayment && (
	                                          <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('card')} className='invoice-form-item--compact' labelClassName={boldLabelClass('PaymentBank')} show={showInvoiceField('PaymentBank')}>
                                                      <Select
                                                          name='payment_bank'
                                                          isDisabled={disableForFocus(false)}
                                                          value={
                                                              this.state.invoice.json.PaymentBank || null
                                                          }
                                                          options={this.state.payment_banks ?? []}
                                                          styles={this.styleSelect}
                                                          classNamePrefix='select'
                                                          formatOptionLabel={formatPaymentBankOption}
                                                          onChange={(choice) => { this.updateInvoice(choice, 'json', 'PaymentBank') }}
                                                      />
                                          </InvoiceFormItem>
                                      )}

	                                      <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.payee_category')}
	                                                       labelClassName={boldLabelClass('PayeeCategory')}
	                                                       show={showInvoiceField('PayeeCategory', supplierPayeeCategory != null && supplierPayeeCategory.toString().trim() !== '')}
	                                      >
                                          <span>{supplierPayeeCategory}</span>
                                      </InvoiceFormItem>

	                                      <InvoiceFormItem data={this.props.data} label={this.props.data.t.read('invoice.supplier_address')}
	                                          labelClassName={boldLabelClass('SupplierAddress')}
	                                          show={showInvoiceField('SupplierAddress', supplierAddress != null && supplierAddress.toString().trim() !== '')}
	                                      >
                                          <span>{supplierAddress}</span>
                                      </InvoiceFormItem>
                                      
                                  </div>
                              </div>
                            

                            {this.props.data.config.frontend_invoice == null || !this.props.data.config.frontend_invoice.hide_cost_details_table ? (
                              <div className='mt-5 mr-3 px-4'>
                                <h4 className=' d-flex justify-content-between'>
                                  <span>
                                    {getLineItemTableTitle(this.props.data, 'cost')}
                                    <span>
                                      <button disabled={locked || (this.addsLinesThroughExpenseForm() && this.isExpenseReportLocked())} className='btn btn-link' onClick={() => this.addItem(true)}>
                                        <FontAwesomeIcon className='text-success' icon={faPlusSquare} />
                                      </button>
                                    </span>
                                  </span>
                                  <div className='text-right'>
                                    <button
                                      hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval') || this.props.data.role === 'Approver'}
                                      className='btn btn-sm btn-xs btn-primary mr-1'
                                      onClick={() => this.setState({ showRequestDetailApproval: true, section: 'billable' })}
                                      disabled={this.state.billablesSelected.length == 0 || locked}
                                    >
                                      {this.props.data.t.read('request_approval')}
                                    </button>
                                    <button
                                      disabled={locked}
                                      hidden={!canRemoveReportLines(this.state.invoice, this.props.data) || deniedLinesOnly}
                                      className={
                                        'btn btn-secondary btn-sm btn-xs ' + (this.state.billablesSelected.length && !locked > 0 ? '' : 'faded')
                                      }
                                      onClick={() => this.confirmDeleteAction('billable')}
                                    >
                                      {this.props.data.t.read('delete')}
                                    </button>
                                  </div>
                                </h4>
                                <table className='table invoice-items-table mt-3 font-xsmall'>
                                  <thead>
                                    <tr>
                                      <th style={{ width: '4%' }}>
                                        <input
                                          type='checkbox'
                                          id='all-billable-checkbox'
                                          checked={
                                            this.state.invoice.json.ListItem &&
                                            this.state.invoice.json.ListItem.filter((item) => this.itemInCostDetail(item)).length ===
                                            this.state.billablesSelected.length &&
                                            this.state.billablesSelected.length > 0
                                          }
                                          onChange={() => { }}
                                          onClick={(e) => this.toggleSelectAll(e.target, 'billable')}
                                        />
                                      </th>
                                      <th className='invoice-line-number text-center' style={{ width: '3rem', whiteSpace: 'nowrap' }} title={this.props.data.t.read('invoice.line_number')} aria-label={this.props.data.t.read('invoice.line_number')}>#</th>
	                                    <th hidden={isInvoiceFieldHidden('BillableDescription')} className={`col-4 ${boldLabelClass('BillableDescription')}`.trim()}>
                                      {this.props.data.t.read('invoice.description')}<span>*</span>
                                    </th>
	                                    <th hidden={!Utils.isEngineType(this.props.data, "legal") || isInvoiceFieldHidden('BillableOffice')} className={`col-2 ${boldLabelClass('BillableOffice')}`.trim()}>
                                      {this.props.data.t.read('office')}
                                    </th>
	                                    <th hidden={this.props.data.config.frontend_invoice.hide_work_date || shouldHideLineWorkDateColumn(this.props.data) || isInvoiceFieldHidden('WorkDate')} className={`col-2 ${boldLabelClass('WorkDate')}`.trim()}>
                                      {this.props.data.t.read('invoice.work_date')}
                                    </th>
	                                    <th hidden={isInvoiceFieldHidden('MatterId')} className={`col-3 ${boldLabelClass('MatterId')}`.trim()}>
                                      {this.props.data.t.read('invoice.matter_id')}<span>*</span>
                                    </th>
	                                    <th hidden={!showAttorney || isInvoiceFieldHidden('LineAttorney')} className={`col-3 ${boldLabelClass('LineAttorney')}`.trim()}>
                                      {this.props.data.t.read('invoice.attorney')}
                                    </th>
	                                    <th hidden={isInvoiceFieldHidden('CostType')} className={`col-2 ${boldLabelClass('CostType')}`.trim()}>{this.props.data.t.read('invoice.cost_type')}</th>
	                                    <th hidden={isInvoiceFieldHidden('BillableTaxCode')} className={`col-2 ${boldLabelClass('BillableTaxCode')}`.trim()}>{this.props.data.t.read('invoice.tax_code')}</th>
	                                    <th hidden={isInvoiceFieldHidden('BillableTotal')} className={`col-2 ${boldLabelClass('BillableTotal')}`.trim()}>
                                      {this.props.data.t.read('invoice.amount')}<span>*</span>
                                    </th>
                                      <th className='col-2 text-center' hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval')}>
                                        {this.props.data.t.read('invoice.approval_type').toUpperCase()}
                                      </th>
                                      {(this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice') && (
                                        <th className='col-1'>
                                          {(() => {
                                            const billableIds = (this.state.invoice.json?.ListItem || []).filter(
                                              (item) => this.itemInCostDetail(item) && lineHasReceipt(item)
                                            ).map((item) => item.checksum);

                                            const allSelected = this.areAllXpenseSelected(billableIds);
                                            const isEmpty = billableIds.length === 0;

                                            return (
                                              <button
                                                className='btn pointer btn-sm'
                                                onClick={() => this.toggleXpenseSelectBulk(billableIds)}
                                                disabled={isEmpty}
                                              >
                                                <FontAwesomeIcon icon={isEmpty ? faEyeSlash : allSelected ? faEye : faEyeSlash} />
                                              </button>
                                            );
                                          })()}
                                        </th>
                                      )}
                                      {Utils.userHasPageAccess(this.props.data, 'redactor') && this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice' && (
                                        <th className='col-1'>
                                          {(() => {
                                            const billableIds = (this.state.invoice.json?.ListItem || []).filter(
                                              (item) => this.isItemBillable(item) && 'RedactedItemId' in item
                                            ).map((item) => item.RedactedItemId);

                                            const allSelected = this.areAllRedactSelected(billableIds);
                                            const isEmpty = billableIds.length === 0;

                                            return (
                                              <button
                                                data-testid='redaction-bulk-toggle-billable'
                                                className='btn pointer btn-sm'
                                                onClick={() => this.toggleRedactSelectBulk(billableIds)}
                                                disabled={isEmpty || this.state.redactionProcessing}
                                              >
                                                <FontAwesomeIcon icon={isEmpty ? faEyeSlash : allSelected ? faEye : faEyeSlash} />
                                              </button>
                                            );
                                          })()}
                                          {this.state.redactionProcessing && (
                                            <FontAwesomeIcon
                                              data-testid='redaction-process-indicator'
                                              className='ml-2 text-secondary infinite-rotate faded'
                                              icon={faSync}
                                            />
                                          )}
                                        </th>
                                      )}
                                      <th style={{ width: '4%' }}></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.invoice.json.ListItem &&
                                      this.state.invoice.json.ListItem.filter((item) => this.itemInCostDetail(item)).map((item) => {
                                        return (
                                          <tr
                                            hidden={
                                              this.state.invoice.user?.username !== this.props.data.username &&
                                              this.props.data.role === 'Approver' &&
                                              item.approver?.username !== this.props.data.username &&
                                              !isCurrentUserAtInvoiceHead(this.state.invoice, this.props.data.username)
                                            }
                                            key={'invoice-item-' + item._view_id}
                                            className={`invoice-row-status-${item.Status?.toLowerCase()}`}
                                          >
                                            <td onClick={(e) => e.stopPropagation()} className='align-middle'>
                                              <input
                                                type='checkbox'
                                                checked={this.state.billablesSelected.indexOf(item) > -1}
                                                className='billable-checkbox'
                                                value={item._view_id}
                                                onChange={(e) => this.toggleItemSelected('billable', item)}
                                              />
                                            </td>
                                            <td className='invoice-line-number align-middle text-center font-weight-bold'>{lineNumberOf(this.state.invoice.json.ListItem, item)}</td>
                                            <td hidden={isInvoiceFieldHidden('BillableDescription')} className={boldValueClass('BillableDescription', `align-middle invoice-row-status-${item.Status?.toLowerCase()}`)}>
                                              <FormTextField
                                                format='textarea-div'
                                                locked={lockForFocus(true)}
                                                classes={`border-0${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                                value={item.Description}
                                                validateChange={(val) => this.updateInvoice(val, 'json', 'ListItem', item._view_id, 'Description')}
                                              />
                                            </td>
                                            <td
                                              className={boldValueClass('BillableOffice', 'align-middle')}
                                              hidden={!Utils.isEngineType(this.props.data, "legal") || isInvoiceFieldHidden('BillableOffice')}
                                            >
                                                <FormAsyncSelect
                                                    searchUrl={"/offices/search"}
                                                    placeholder={this.props.data.t.read('office')}
                                                    value={lineOfficeValue(this.props.data.config, item)}
                                                    onChange={(val) => this.updateInvoice({ ...item, ...lineOfficeChange(this.props.data.config, val?.value ?? '') }, 'json', 'ListItem', item._view_id)}
                                                    isDisabled={disableForFocus(false)}
                                                />
                                            </td>
                                            <td className={boldValueClass('WorkDate', 'align-middle')} hidden={this.props.data.config.frontend_invoice.hide_work_date || shouldHideLineWorkDateColumn(this.props.data) || isInvoiceFieldHidden('WorkDate')}>
                                              <FormTextField
                                                format='date'
                                                locked={lockForFocus(false)}
                                                value={item.WorkDate ? item.WorkDate : this.state.invoice.json.WorkDate}
                                                validateChange={(val) => this.updateInvoice(val, 'json', 'ListItem', item._view_id, 'WorkDate')}
                                              />
                                            </td>
                                            <td hidden={isInvoiceFieldHidden('MatterId')} className={boldValueClass('MatterId', 'align-middle')}>
                                              <div className='d-flex align-items-center'>
                                                <AutoCompleteField
                                                  value={item.MatterId ?? ''}
                                                  onChange={(val) => this.updateLineMatter(item, val)}
                                                  className={`form-control pl-0 border-0${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                                  searchUrl='/matters/search/'
                                                  resolveValue={this.resolveMatterValue}
                                                  // XPEN-3322: the picker edits the collapsed number; the full one is
                                                  // restored before it is stored, so MatterId still resolves at export.
                                                  formatEditValue={formatMatterNumber}
                                                  parseEditValue={expandMatterNumber}
                                                  minLength={1}
                                                  disabled={disableForFocus(true)}
                                                  placeholder={this.props.data.t.read('invoice.matter_id')}
                                                  formatLabel={(m) => formatMatterLabelFromData(this.props.data, m)}
                                                />
                                                {shouldShowActivityInlineTrigger(this.props.data) && (
                                                <div
                                                  onClick={() =>
                                                    this.setState({
                                                      showAdditionalFieldsModal: true,
                                                      workItem: item,
                                                      additionalFieldsFilter: buildActivityAdditionalFieldsFilter(this.props.data),
                                                    })
                                                  }
                                                >
                                                  <HoverInfoCard
                                                    info={
                                                      <FontAwesomeIcon icon={faExclamationTriangle} className='text-primary pointer' size={'2x'} />
                                                    }
                                                    position='pos-top-right'
                                                    additionalInfo={
                                                      <>
                                                        <div style={{ minWidth: '200px', textTransform: 'none' }}>
                                                          <strong className='mr-2'>{this.props.data.t.read('validation_error')} </strong>
                                                          <strong>{this.props.data.t.read('invoice.activity')}</strong>
                                                          <div>
                                                            <p className='mb-0 mt-2 italic'>
                                                              {this.props.data.t.read('click_to')} {this.props.data.t.read('select')}{' '}
                                                              {this.props.data.t.read('invoice.activity')}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      </>
                                                    }
                                                    shouldDisplayIcon={(callback) => {
                                                      this.getMatterInfo(item.MatterId, (matterInfo) => {
                                                        if (!matterInfo) return callback(false);
                                                        callback(getActivityMissingKeys(item, matterInfo).length > 0);
                                                      });
                                                    }}
                                                  />
                                                </div>
                                                )}
                                              </div>
                                            </td>
                                            <td hidden={!showAttorney || isInvoiceFieldHidden('LineAttorney')} className={boldValueClass('LineAttorney', 'align-middle')}>
                                              {showAttorney && (
                                              <FormAsyncSelect
                                                data={this.props.data}
                                                inputId={`line-attorney-${item._view_id}`}
                                                name='AttorneyId'
                                                isDisabled={disableForFocus(true)}
                                                isClearable
                                                // Identity, not a rebuilt copy, and no focus seeding:
                                                // both are what let the menu open on the current choice.
                                                optionMap={(option) => option}
                                                seedInputOnFocus={false}
                                                value={this.attorneyOption(item.AttorneyId)}
                                                loadOptions={this.attorneyLoaderFor(item.AttorneyId)}
                                                onChange={(choice) => this.updateInvoice(choice ?? undefined, 'json', 'ListItem', item._view_id, 'AttorneyId')}
                                                placeholder={headerAttorneyCode || this.props.data.t.read('invoice.attorney')}
                                                stylesOverride={LINE_SELECT_STYLE}
                                                formatOptionLabel={formatLineAttorneyOption}
                                              />
                                              )}
                                            </td>
                                            <td hidden={isInvoiceFieldHidden('CostType')} className={boldValueClass('CostType', 'align-middle p-0')}>
                                              <div className='d-flex align-items-center'>
                                                <AutoCompleteField
                                                  value={item.CostType}
                                                  onChange={(val) => {
                                                    const costTypeValue = val?.name ?? val;
                                                    this.updateLineItemAndDescription(item._view_id, 'CostType', costTypeValue, val);
                                                  }}
                                                  className='form-control border-0'
                                                  searchUrl='/cost_type/search/'
                                                  disabled={disableForFocus(false)}
                                                  minLength={1}
                                                  placeholder={this.props.data.t.read('invoice.cost_type')}
                                                />
                                                {this.renderRequiredFieldsIcon(item, /* isBillable */ true)}
                                              </div>
                                            </td>
                                            <td hidden={isInvoiceFieldHidden('BillableTaxCode')} className={boldValueClass('BillableTaxCode', 'align-middle')}>
                                              <TaxCodeSelector
                                                taxCodes={this.taxcodes}
                                                disabled={disableForFocus(false) || !!expenseAmountLock}
                                                value={item.TaxCode
                                                  ? item.TaxCode
                                                  : this.state.invoice.json.TaxCode
                                                    ? this.state.invoice.json.TaxCode
                                                    : this.defaultTaxCode}
                                                onChange={(newTaxCode) => {
                                                  if(this.state.invoice.type === 'XPENSE') {
                                                      this.updateExpenseDetails({...item, TaxCode: newTaxCode});
                                                  }
                                                  else {
                                                      this.changeTaxCodeTo(newTaxCode, item._view_id)
                                                  }
                                                }}
                                              />
                                            </td>
                                            <td hidden={isInvoiceFieldHidden('BillableTotal')} className={boldValueClass('BillableTotal', 'align-middle')}>
                                              <AmountsSummaryTooltip
                                                amountsSummary={item.amounts_summary}
                                                data={this.props.data}
                                                disabled={this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice'}
                                                onClick={() => this.setState({ showExpenseItemModal: true, workItem: item, expenseDetailsError: null })}

                                              >
                                                <FormTextField
                                                  format='money'
                                                  locked={lockForFocus(true) || this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice'}
                                                  value={item.Total}
                                                  classes={`pointer${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                                  validateChange={(val) => {
                                                      if (this.state.invoice.json?.Model === 'CMPA') {
                                                          const total = toNumber(val);
                                                          const rate = toNumber(item.WorkRate);
                                                          const quantity = rate > 0 ? total / rate : 0;
                                                          const nextItem = {
                                                              ...item,
                                                              Total: total,
                                                              WorkQuantity: quantity,
                                                              WorkTotal: quantity * rate,
                                                          };

                                                          this.updateInvoice(nextItem, 'json', 'ListItem', item._view_id,);
                                                      }
                                                      else this.updateInvoice(val, 'json', 'ListItem', item._view_id, 'Total');

                                                      this.computeTaxes();
                                                  }}
                                                />
                                              </AmountsSummaryTooltip>
                                            </td>
                                            <td
                                              className='align-middle'
                                              hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval')}
                                            >
                                              <LineApprovalHistory item={item} data={this.props.data}>
                                                <div className='d-flex text-center justify-content-center'>
                                                  <Checkmark
                                                    circle={false}
                                                    callback={() => this.fetchInvoice()}
                                                    disabled={
                                                      item.Status !== 'Need_Approval' ||
                                                      !canDecideLine(item, this.props.data) ||
                                                      !Utils.userHasRole(this.props.data, ['Admin', 'Approver']) ||
                                                      !AccessControl.hasActionAccess(this.props.data, 'canApproveOrDeny') ||
                                                      locked
                                                    }
                                                    data={this.props.data}
                                                    isChecked={item.Status === 'Approved'}
                                                    onChecked={() => this.decideLineApproval(item, 'approve')}
                                                  />
                                                  <Closemark
                                                    callback={() => this.fetchInvoice()}
                                                    disabled={
                                                      item.Status !== 'Need_Approval' ||
                                                      !canDecideLine(item, this.props.data) ||
                                                      !Utils.userHasRole(this.props.data, ['Admin', 'Approver']) ||
                                                      !AccessControl.hasActionAccess(this.props.data, 'canApproveOrDeny') ||
                                                      locked
                                                    }
                                                    data={this.props.data}
                                                    isClosed={item.Status === 'Denied'}
                                                    onClosed={(causeDenial) => this.disApproveDetail(item, causeDenial)}
                                                  />
                                                </div>
                                              </LineApprovalHistory>
                                            </td>
                                            {(this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice') && (
                                              <td className='align-middle pointer'>
                                                <button
                                                  disabled={!lineHasReceipt(item) || locked}
                                                  title={item._added_from_invoice ? this.props.data.t.read('invoice.add_expense.no_receipt') : undefined}
                                                  className={'btn pointer'}
                                                  onClick={() => this.toggleXpenseSelect(item.checksum)}
                                                >
                                                  <FontAwesomeIcon className='' icon={this.isXpenseSelected(item.checksum) ? faEye : faEyeSlash} />
                                                </button>
                                              </td>
                                            )}
                                            {Utils.userHasPageAccess(this.props.data, 'redactor') && this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice' && (
                                              <td className='align-middle pointer'>
                                                <button
                                                  data-testid={`redaction-item-toggle-${item.RedactedItemId}`}
                                                  disabled={isRedactionSelectionDisabled({
                                                    hasSelectableId: 'RedactedItemId' in item,
                                                    isLocked: locked,
                                                    isProcessing: this.state.redactionProcessing,
                                                  })}
                                                  className={'btn pointer'}
                                                  onClick={() => this.toggleRedactSelect(item.RedactedItemId)}
                                                >
                                                  <FontAwesomeIcon
                                                    className=''
                                                    icon={this.isRedactSelected(item.RedactedItemId) ? faEye : faEyeSlash}
                                                  />
                                                </button>
                                              </td>
                                            )}
                                            <td>
                                              <div className={'d-flex flex-column align-items-center p-0 m-0'}>
                                                <FontAwesomeIcon
                                                  icon={faEllipsisH}
                                                  className={'pointer'}
                                                  onClick={() =>
                                                    this.setState({
                                                      showAdditionalFieldsModal: true,
                                                      workItem: item,
                                                      additionalFieldsFilter: buildBillableAdditionalFieldsFilter(this.props.data, {
                                                        model: this.state.invoice.json?.Model,
                                                      }),
                                                    })
                                                  }
                                                />

                                                {canRemoveReportLines(this.state.invoice, this.props.data) && canEditReportLine(this.state.invoice, item) && (
                                                  <FontAwesomeIcon
                                                    className={`text-danger mt-2 pointer ${locked && 'faded'}`}
                                                    icon={faWindowClose}
                                                    onClick={() => !locked && this.confirmRemoveLine(item._view_id)}
                                                  />
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                            ) : null}

                            <div className='mt-5 mr-3 px-4'>
                              <h4 className='d-flex justify-content-between'>
                                <span>
                                  {getLineItemTableTitle(this.props.data, 'gl')}
                                  <span>
                                    <button className='btn btn-link' disabled={locked || (this.addsLinesThroughExpenseForm() && this.isExpenseReportLocked())} onClick={() => this.addItem(false)}>
                                      <FontAwesomeIcon className='text-success' icon={faPlusSquare} />
                                    </button>
                                  </span>
                                </span>
                                <div className='text-right'>
                                  <button
                                    hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval') || this.props.data.role === 'Approver'}
                                    className='btn btn-sm btn-xs btn-primary mr-1'
                                    onClick={() => this.setState({ showRequestDetailApproval: true, section: 'non-billable' })}
                                    disabled={this.state.nonBillablesSelected.length == 0 || locked}
                                  >
                                    {this.props.data.t.read('request_approval')}
                                  </button>
                                  <button
                                    className={
                                      'btn btn-secondary btn-sm btn-xs ' + (this.state.nonBillablesSelected.length && !locked > 0 ? '' : 'faded')
                                    }
                                    disabled={locked}
                                    hidden={!canRemoveReportLines(this.state.invoice, this.props.data) || deniedLinesOnly}
                                    onClick={() => this.confirmDeleteAction('non-billable')}
                                  >
                                    {this.props.data.t.read('delete')}
                                  </button>
                                </div>
                              </h4>
                              <table className='table invoice-items-table mt-3 font-xsmall'>
                                <thead>
                                  <tr>
                                    <th style={{ width: '4%' }}>
                                      <input
                                        type='checkbox'
                                        id='all-non-billable-checkbox'
                                        checked={
                                          this.state.invoice.json.ListItem &&
                                          this.state.invoice.json.ListItem.filter((item) => this.itemInGlDetail(item)).length ===
                                          this.state.nonBillablesSelected.length &&
                                          this.state.nonBillablesSelected.length > 0
                                        }
                                        onChange={() => { }}
                                        onClick={(e) => this.toggleSelectAll(e.target, 'non-billable')}
                                      />
                                    </th>
                                    <th className='invoice-line-number text-center' style={{ width: '3rem', whiteSpace: 'nowrap' }} title={this.props.data.t.read('invoice.line_number')} aria-label={this.props.data.t.read('invoice.line_number')}>#</th>
	                                    <th hidden={isInvoiceFieldHidden('NonBillableDescription')} className={`col-5 ${boldLabelClass('NonBillableDescription')}`.trim()}>
                                      {this.props.data.t.read('invoice.description')}<span>*</span>
                                    </th>
	                                    <th hidden={!shouldShowLineGlUnitColumn(this.props.data) || isInvoiceFieldHidden('LineGLUnit')} className={`col-2 ${boldLabelClass('LineGLUnit')}`.trim()}>
                                      {this.props.data.t.read(segmentLabelKey(this.props.data.config, 'GLUnit', 'invoice.unit'))}
                                    </th>
	                                    <th hidden={!Utils.isEngineType(this.props.data, "legal") || isInvoiceFieldHidden('NonBillableOffice')} className={`col-2 ${boldLabelClass('NonBillableOffice')}`.trim()}>
                                      {this.props.data.t.read(shouldUseInvoiceOfficeLabel(this.props.data) ? 'invoice.office' : 'office')}
                                    </th>
	                                    {hasSegmentRules(this.props.data, GL_FACILITY) && (
	                                      <th className="col-3" data-testid="invoice-line-gloffice-rules-header">{this.props.data.t.read('gl_segment.facility')}</th>
	                                    )}
	                                    <th hidden={isInvoiceFieldHidden('GLNatural')} className={`col-3 ${boldLabelClass('GLNatural')}`.trim()}>
                                      {this.props.data.t.read('invoice.gl_nat')}<span>*</span>
                                    </th>
	                                    <th hidden={isInvoiceFieldHidden('NonBillableTaxCode')} className={`col-2 ${boldLabelClass('NonBillableTaxCode')}`.trim()}>{this.props.data.t.read('invoice.tax_code')}</th>
	                                    <th hidden={isInvoiceFieldHidden('NonBillableTotal')} className={`col-3 ${boldLabelClass('NonBillableTotal')}`.trim()}>
                                      {this.props.data.t.read('invoice.amount')}<span>*</span>
                                    </th>
                                    <th className='col-2 text-center' hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval')}>
                                      {this.props.data.t.read('invoice.approval_type').toUpperCase()}
                                    </th>
                                    {(this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice') && (
                                      <th className='col-1'>
                                        {(() => {
                                          const unbillableIds = (this.state.invoice.json?.ListItem || []).filter(
                                            (item) => this.itemInGlDetail(item) && lineHasReceipt(item)
                                          ).map((item) => item.checksum);

                                          const allSelected = this.areAllXpenseSelected(unbillableIds);
                                          const isEmpty = unbillableIds.length === 0;

                                          return (
                                            <button
                                              className='btn pointer'
                                              onClick={() => this.toggleXpenseSelectBulk(unbillableIds)}
                                              disabled={isEmpty}
                                            >
                                              <FontAwesomeIcon icon={isEmpty ? faEyeSlash : allSelected ? faEye : faEyeSlash} />
                                            </button>
                                          );
                                        })()}
                                      </th>
                                    )}
                                    {Utils.userHasPageAccess(this.props.data, 'redactor') && this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice' && (
                                      <th className='col-1'>
                                        {(() => {
                                          const unbillableIds = (this.state.invoice.json?.ListItem || []).filter(
                                            (item) => !this.isItemBillable(item) && 'RedactedItemId' in item
                                          ).map((item) => item.RedactedItemId);

                                          const allSelected = this.areAllRedactSelected(unbillableIds);
                                          const isEmpty = unbillableIds.length === 0;

                                          return (
                                            <button
                                              data-testid='redaction-bulk-toggle-non-billable'
                                              className='btn pointer'
                                              onClick={() => this.toggleRedactSelectBulk(unbillableIds)}
                                              disabled={isEmpty || this.state.redactionProcessing}
                                            >
                                              <FontAwesomeIcon icon={isEmpty ? faEyeSlash : allSelected ? faEye : faEyeSlash} />
                                            </button>
                                          );
                                        })()}
                                        {this.state.redactionProcessing && (
                                          <FontAwesomeIcon
                                            className='ml-2 text-secondary infinite-rotate faded'
                                            icon={faSync}
                                          />
                                        )}
                                      </th>
                                    )}
                                    <th style={{ width: '4%' }}></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.invoice.json.ListItem &&
                                    this.state.invoice.json.ListItem.filter((item) => this.itemInGlDetail(item)).map((item) => {
                                      return (
                                        <tr
                                          hidden={
                                            this.state.invoice.user?.username !== this.props.data.username &&
                                            this.props.data.role === 'Approver' &&
                                            item.approver?.username !== this.props.data.username &&
                                            !isCurrentUserAtInvoiceHead(this.state.invoice, this.props.data.username)
                                          }
                                          key={'invoice-gl-item-' + item._view_id}
                                          className={`invoice-row-status-${item.Status?.toLowerCase()}`}
                                        >
                                          <td onClick={(e) => e.stopPropagation()} className='align-middle'>
                                            <input
                                              type='checkbox'
                                              checked={this.state.nonBillablesSelected.indexOf(item) > -1}
                                              className='non-billable-checkbox'
                                              value={item._view_id}
                                              onChange={(e) => this.toggleItemSelected('non-billable', item)}
                                            />
                                          </td>
                                          <td className='invoice-line-number align-middle text-center font-weight-bold'>{lineNumberOf(this.state.invoice.json.ListItem, item)}</td>
	                                          <td hidden={isInvoiceFieldHidden('NonBillableDescription')} className={boldValueClass('NonBillableDescription', 'align-middle')}>
                                            <FormTextField
                                              format='textarea-div'
                                              classes={`border-0${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                              locked={lockForFocus(true)}
                                              value={item.Description}
                                              maxLength={eliteGlDescriptionMaxLength}
                                              validateChange={(val) => this.updateInvoice(val, 'json', 'ListItem', item._view_id, 'Description')}
                                            />
                                          </td>
                                          <td
                                            className={boldValueClass('LineGLUnit', 'align-middle')}
                                            hidden={!shouldShowLineGlUnitColumn(this.props.data) || isInvoiceFieldHidden('LineGLUnit')}
                                          >
                                              <FormAsyncSelect
                                                  searchUrl={"/suppliers/unit/search"}
                                                  placeholder={this.props.data.t.read(segmentLabelKey(this.props.data.config, 'GLUnit', 'invoice.unit'))}
                                                  value={item.GLUnit ?? null}
                                                  optionMap={(option) => {
                                                      const name = option.name ?? "";
                                                      const description = option.description ?? "";
                                                      return {
                                                          value: { name, unit: option.unit },
                                                          label: option.label ?? `${name}${description ? ` (${description})` : ""}`,
                                                          name,
                                                          description,
                                                      };
                                                  }}
                                                  onChange={(val) => {
                                                      const nextItem = {
                                                          ...item,
                                                          GLUnit:  val?.value?.name,
                                                          GLOffice: this.props.data?.config?.unit_is_office === true
                                                            ? val?.value?.unit
                                                            : item.GLOffice
                                                      }
                                                      this.updateInvoice(nextItem, 'json', 'ListItem', item._view_id,);
                                                  }}
                                                  isDisabled={disableForFocus(false)}
                                              />
                                          </td>

                                          <td
                                            className={boldValueClass('NonBillableOffice', 'align-middle')}
                                            hidden={!Utils.isEngineType(this.props.data, "legal") || isInvoiceFieldHidden('NonBillableOffice')}
                                          >
                                            {shouldUseInvoiceOfficeLabel(this.props.data) ?
                                              <AutoCompleteField
                                                value={item.GLOffice ?? ''}
                                                onChange={(val) => this.updateInvoice(val?.name ?? val ?? '', 'json', 'ListItem', item._view_id, 'GLOffice')}
                                                className='form-control border-0 pl-0'
                                                searchUrl='/offices/search/'
                                                minLength={1}
                                                disabled={disableForFocus(false)}
                                                placeholder={this.props.data.t.read('invoice.office')}
                                              /> :
                                                <FormAsyncSelect
                                                    searchUrl={"/offices/search"}
                                                    placeholder={this.props.data.t.read('office')}
                                                    value={lineOfficeValue(this.props.data.config, item)}
                                                    onChange={(val) => this.updateInvoice({ ...item, ...lineOfficeChange(this.props.data.config, val?.value ?? '') }, 'json', 'ListItem', item._view_id)}
                                                    isDisabled={disableForFocus(false)}
                                                />
                                            }
                                          </td>
                                          {hasSegmentRules(this.props.data, GL_FACILITY) && (
                                            <td className="align-middle">
                                              {!isBillableLine(item) && <SegmentRuleField
                                                item={item}
                                                segment={GL_FACILITY}
                                                data={this.props.data}
                                                label={this.props.data.t.read('gl_segment.facility')}
                                                isDisabled={disableForFocus(false)}
                                                onChange={(updatedItem) => this.updateInvoice(updatedItem, 'json', 'ListItem', item._view_id)}
                                              />}
                                            </td>
                                          )}
                                            
	                                          <td hidden={isInvoiceFieldHidden('GLNatural')} className={boldValueClass('GLNatural', 'align-middle')}>
                                              <div className='d-flex align-items-center'>
                                                {Utils.isExportFormat(this.props.data, "elite") ?
                                                    <AutoCompleteField
                                                        value={item.GLNatural ?? ''}
                                                        onChange={(val) => {
                                                          const glNaturalValue = val?.name ?? val;
                                                          this.updateLineItemAndDescription(item._view_id, 'GLNatural', glNaturalValue, val);
                                                        }}
                                                        className={`form-control border-0 pl-0${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                                        searchUrl='/gl/nat/search/'
                                                        minLength={1}
                                                        disabled={disableForFocus(true)}
                                                        placeholder={this.props.data.t.read('invoice.gl_natural')}
                                                    /> :
                                                    <FormAsyncSelect
                                                        searchUrl={"/gl/nat/search"}
                                                        placeholder={this.props.data.t.read('gl_natural')}
                                                        value={item.GLNatural ?? null}
                                                        onChange={(val) => {
                                                          const glNaturalValue = val?.value;
                                                          this.updateLineItemAndDescription(item._view_id, 'GLNatural', glNaturalValue, val);
                                                        }}
                                                        isDisabled={disableForFocus(true)}
                                                        highlightAll={isFocusedInvoice}
                                                    />
                                                }
                                                {this.renderRequiredFieldsIcon(item, /* isBillable */ false)}
                                              </div>
                                          </td>
	                                          <td hidden={isInvoiceFieldHidden('NonBillableTaxCode')} className={boldValueClass('NonBillableTaxCode', 'align-middle')}>
                                            <TaxCodeSelector
                                              taxCodes={this.taxcodes}
                                              disabled={disableForFocus(false) || !!expenseAmountLock}
                                              value={item.TaxCode
                                                ? item.TaxCode
                                                : this.state.invoice.json.TaxCode
                                                  ? this.state.invoice.json.TaxCode
                                                  : this.defaultTaxCode}
                                              onChange={(newTaxCode) => {
                                                if(this.state.invoice.type === 'XPENSE') {
                                                    this.updateExpenseDetails({...item, TaxCode: newTaxCode});
                                                }
                                                else {
                                                    this.changeTaxCodeTo(newTaxCode, item._view_id)
                                                }
                                              }}
                                            />
                                          </td>

	                                          <td hidden={isInvoiceFieldHidden('NonBillableTotal')} className={boldValueClass('NonBillableTotal', 'align-middle')}>
                                            <AmountsSummaryTooltip
                                              amountsSummary={item.amounts_summary}
                                              data={this.props.data}
                                              disabled={this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice'}
                                              onClick={() => this.setState({ showExpenseItemModal: true, workItem: item, expenseDetailsError: null })}

                                            >
                                              <FormTextField
                                                format='money'
                                                locked={lockForFocus(true) || this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice'}
                                                value={item.Total}
                                                classes={`pointer${isFocusedInvoice ? " border-highlight-secondary" : ""}`}
                                                validateChange={(val) => {
                                                  this.updateInvoice(val, 'json', 'ListItem', item._view_id, 'Total');
                                                  this.computeTaxes();
                                                }}
                                              />
                                            </AmountsSummaryTooltip>
                                          </td>
                                          <td
                                            className='align-middle'
                                            hidden={!Utils.userHasPageAccess(this.props.data, 'detail-approval')}
                                          >
                                            <LineApprovalHistory item={item} data={this.props.data}>
                                              <div className='d-flex text-center justify-content-center'>
                                                <Checkmark
                                                  circle={false}
                                                  callback={() => this.fetchInvoice()}
                                                  disabled={
                                                    item.Status !== 'Need_Approval' ||
                                                      !canDecideLine(item, this.props.data) ||
                                                    !Utils.userHasRole(this.props.data, ['Admin', 'Approver']) ||
                                                    !AccessControl.hasActionAccess(this.props.data, 'canApproveOrDeny') ||
                                                    locked
                                                  }
                                                  data={this.props.data}
                                                  isChecked={item.Status === 'Approved'}
                                                  onChecked={() => this.decideLineApproval(item, 'approve')}
                                                />
                                                <Closemark
                                                  callback={() => this.fetchInvoice()}
                                                  disabled={
                                                    item.Status !== 'Need_Approval' ||
                                                      !canDecideLine(item, this.props.data) ||
                                                    !Utils.userHasRole(this.props.data, ['Admin', 'Approver']) ||
                                                    !AccessControl.hasActionAccess(this.props.data, 'canApproveOrDeny') ||
                                                    locked
                                                  }
                                                  data={this.props.data}
                                                  isClosed={item.Status === 'Denied'}
                                                  onClosed={(causeDenial) => this.disApproveDetail(item, causeDenial)}
                                                />
                                              </div>
                                            </LineApprovalHistory>
                                          </td>
                                          {(this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice') && (
                                            <td className='align-middle pointer'>
                                              <button
                                                disabled={!lineHasReceipt(item)}
                                                title={item._added_from_invoice ? this.props.data.t.read('invoice.add_expense.no_receipt') : undefined}
                                                className={'btn pointer'}
                                                onClick={() => this.toggleXpenseSelect(item.checksum)}
                                              >
                                                <FontAwesomeIcon className='' icon={this.isXpenseSelected(item.checksum) ? faEye : faEyeSlash} />
                                              </button>
                                            </td>
                                          )}
                                          {Utils.userHasPageAccess(this.props.data, 'redactor') && this.state.invoice.type !== 'XPENSE' && this.state.invoice.transaction_type !== 'expense_invoice' && (
                                            <td className='align-middle pointer'>
                                              <button
                                                data-testid={`redaction-item-toggle-${item.RedactedItemId}`}
                                                disabled={isRedactionSelectionDisabled({
                                                  hasSelectableId: 'RedactedItemId' in item,
                                                  isProcessing: this.state.redactionProcessing,
                                                })}
                                                className={'btn pointer'}
                                                onClick={() => this.toggleRedactSelect(item.RedactedItemId)}
                                              >
                                                <FontAwesomeIcon
                                                  className=''
                                                  icon={this.isRedactSelected(item.RedactedItemId) ? faEye : faEyeSlash}
                                                />
                                              </button>
                                            </td>
                                          )}
                                          <td>
                                            <div className={'d-flex flex-column align-items-center p-0 m-0'}>
                                              <FontAwesomeIcon
                                                icon={faEllipsisH}
                                                className={'pointer'}
                                                data-testid={`gl-line-more-${item._view_id}`}
                                                onClick={() => {
                                                  this.setState({
                                                    showAdditionalFieldsModal: true,
                                                    workItem: item,
                                                    additionalFieldsFilter: buildGlAdditionalFieldsFilter(this.props.data, {
                                                      isLegalEngine: Utils.isEngineType(this.props.data, 'legal'),
                                                    }),
                                                  });
                                                  this.loadLineSplitNotice(item);
                                                }}
                                              />

                                              {canRemoveReportLines(this.state.invoice, this.props.data) && canEditReportLine(this.state.invoice, item) && (
                                                <FontAwesomeIcon
                                                  className={`text-danger mt-2 pointer ${locked && 'faded'}`}
                                                  icon={faWindowClose}
                                                  onClick={() => !locked && this.confirmRemoveLine(item._view_id)}
                                                />
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <div className='d-flex px-4 align-items-center justify-content-start' style={{ display: this.showStatus(total) }}>
                              <div>{this.props.data.t.read('invoice.total')} :</div>
                              <div className='invoice-value ml-5'>
                                <FormTextField
                                  format='money'
                                  locked={true}
                                  value={total}
                                  validateChange={(val) => {
                                    this.updateInvoice(val, 'json', 'Total');
                                    this.computeGrandTotal();
                                  }}
                                />
                              </div>
                            </div>

                            <h4
                              className='mt-5 px-4 mb-2'
                              style={{ display: this.showStatus(tax1) === 'flex' || this.showStatus(tax2) === 'flex' ? 'block' : 'none' }}
                            >
                              {this.props.data.t.read('invoice.tax_details')}
                            </h4>
                              <div className='invoice-form-items-grid'>
                                  <div className='invoice-form-items-grid__column'>
                                      {
                                          !this.props.data.config.hide_tax_1_field && (
	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={
	                                                      !this.props.data.config?.tax_1_label
	                                                          ? `${this.props.data.t.read('invoice.tax')} 1`
	                                                          : this.props.data.config.tax_1_label
	                                                  }
	                                                  className='px-4'
	                                                  labelClassName={boldLabelClass('Tax1')}
	                                                  show={showInvoiceField('Tax1', this.showStatus(tax1) === 'flex')}
	                                              >
                                                  <FormTextField
                                                      format='money'
                                                      locked={lockForFocus(false)}
                                                      value={tax1}
                                                      validateChange={(val) => {
                                                          this.updateInvoice(val, 'json', 'Tax1');
                                                          this.computeGrandTotal();
                                                      }}
                                                  />
                                              </InvoiceFormItem>
                                          )
                                      }

                                      {
                                          !this.props.data.config.hide_tax_2_field && (
	                                              <InvoiceFormItem
	                                                  data={this.props.data}
	                                                  label={
	                                                      !this.props.data.config?.tax_2_label
	                                                          ? `${this.props.data.t.read('invoice.tax')} 2`
	                                                          : this.props.data.config.tax_2_label
	                                                  }
	                                                  className='px-4'
	                                                  labelClassName={boldLabelClass('Tax2')}
	                                                  show={showInvoiceField('Tax2', this.showStatus(tax2) === 'flex')}
	                                              >
                                                  <FormTextField
                                                      format='money'
                                                      locked={lockForFocus(false)}
                                                      value={tax2}
                                                      validateChange={(val) => {
                                                          this.updateInvoice(val, 'json', 'Tax2');
                                                          this.computeGrandTotal();
                                                      }}
                                                  />
                                              </InvoiceFormItem>
                                          )
                                      }

	                                      <InvoiceFormItem
	                                          data={this.props.data}
	                                          label={this.props.data.t.read('invoice.total_with_tax')}
	                                          className='px-4'
	                                          labelClassName={boldLabelClass('TotalWithTax')}
	                                          show={showInvoiceField('TotalWithTaxBottom', this.showStatus(total) === 'flex')}
	                                      >
                                          <FormTextField
                                              format='money'
                                              locked={true}
                                              value={totalWithTax}
                                              validateChange={(val) => this.updateInvoice(val, 'json', 'TotalWithTax')}
                                          />
                                      </InvoiceFormItem>
                                  </div>
                              </div>
                            {!isInvoiceFieldHidden('InvoiceComments') && hasInvoiceCommentIdentity(this.state.invoice) &&
                              <CommentsPanel key={this.id} invoiceId={this.id} refreshKey={this.state.commentsRefresh}
                                data={this.props.data} legacyText={legacyCommentsText(this.state.invoice)} onDraftChange={this.onCommentDraftChange} />}
	                            {!isInvoiceFieldHidden('InvoiceComments') && !hasInvoiceCommentIdentity(this.state.invoice) && <h4 className={`mt-5 px-4 ${boldLabelClass('InvoiceComments')}`.trim()}>{this.props.data.t.read('comments')}</h4>}

	                            {!isInvoiceFieldHidden('InvoiceComments') && !hasInvoiceCommentIdentity(this.state.invoice) && <div className={boldValueClass('InvoiceComments', 'card mx-4')}>
	                              <FormTextAreaAutoSaved
	                                locked={lockForFocus(true)}
	                                highlightClass={isFocusedInvoice ? "border-highlight-secondary" : ""}
	                                value={this.state.invoice.json.comments || ''}
	                                validateChange={(val) => this.updateInvoice(val, 'json', 'comments')}
	                              />
	                            </div>}

                            <div className='d-inline-flex align-items-center mt-2 px-4'>
                              {/* XPEN-1622: HoverInfoCard shows finalization/partner errors (finalization_errors or legacy: content before engine block); engine errors never shown here. */}
                              <HoverInfoCard
                                info={
                                  <FontAwesomeIcon icon={faExclamationTriangle} className='text-primary pointer' size={'2x'} />
                                }
                                displayOnClick={true}
                                position='pos-top-right no-max'
                                backgroundColor='white'
                                additionalInfo={
                                  <div className='text-left' style={{ minWidth: '300px', textTransform: 'none', maxHeight: '300px', overflowY: 'auto' }}>
                                    <div className='font-weight-bold card-header'>{this.props.data.t.read('errors.invoice')}</div>
                                    <div className='card-body'>
                                      {(() => {
                                        const partnerErrors = getPartnerErrorsForDisplay(this.state.invoice);
                                        if (partnerErrors.length === 0) return null;
                                        // XPEN-1622: Add visual separation between partner blocks (e.g. lines starting with timestamp); no partner-specific label assumed.
                                        const timestampStart = /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/;
                                        return (
                                          <ul className='pl-4 mb-2'>
                                            {partnerErrors.map((msg, i) => (
                                              <React.Fragment key={i}>
                                                {i > 0 && timestampStart.test(msg) ? (
                                                  <li className='list-unstyled border-top pt-2 mt-2' aria-hidden="true" />
                                                ) : null}
                                                <li>{msg}</li>
                                              </React.Fragment>
                                            ))}
                                          </ul>
                                        );
                                      })()}
                                    </div>
                                  </div>
                                }
                                shouldDisplayIcon={(callback) => {
                                  // XPEN-1622: Icon visible only when status is Validated and there are partner errors (finalization_errors or legacy status_details). Hidden for Finalized and all other statuses.
                                  callback(shouldShowPartnerErrorsIcon(this.state.invoice));
                                }}
                              />
                            </div>

                            <div className='mt-4 px-4'>
                              <div id='errorMessages' className='errors'></div>
                            </div>
                          </div>
                        ) : (
                          <LogHistory data={this.props.data} invoiceId={this.id} />
                        )}
                        </div>
                        {this.state.currentView === 'data' && (
                            <div className='invoice-actions'>
                            {(Utils.userHasRole(this.props.data, ['Admin', 'Manager', 'Clerk', 'Assistant']) ||
                              AccessControl.hasActionAccess(this.props.data, 'canRequestApproval') ||
                              AccessControl.hasActionAccess(this.props.data, 'canValidateInvoices') ||
                              AccessControl.hasActionAccess(this.props.data, 'canRedact') ||
                              AccessControl.hasActionAccess(this.props.data, 'canRestartProcessing')) && (
                                <div className='d-flex justify-content-between'>
                                  <div className={'w-100'}>
                                    {this.state.invoice.status !== 'Need_Approval' && (
                                      <div className={'d-flex '}>
                                        <div className={''}>
                                            {
                                                (!['XPENSE', 'p-card'].includes(this.state.invoice.type) || this.state.invoice.transaction_type === 'expense_invoice') &&
                                                <button
                                                    className='btn btn-sm btn-secondary mr-2'
                                                    disabled={locked || finalized}
                                                    onClick={() => this.setState({ showConfirmRestartProcess: true })}
                                                >
                                                    {this.props.data.t.read('invoice.restart_processing')}
                                                </button>
                                            }
                                          
                                          <button
                                            className='btn btn-sm btn-secondary'
                                            disabled={locked || finalized}
                                            onClick={() => this.setState({ showConfirmRestartPostProcess: true })}
                                          >
                                            {this.props.data.t.read('invoice.restart_post_processing')}
                                          </button>
                                          {Utils.userHasPageAccess(this.props.data, 'redactor') && (
                                            <Tooltip
                                              message={
                                                (this.state.invoice.type === 'XPENSE' || this.state.invoice.transaction_type === 'expense_invoice')
                                                  ? this.props.data.t.read('redaction.disabled_for_xpense_invoices')
                                                  : ''
                                              }
                                            >
                                              <button
                                                data-testid='redaction-action-button'
                                                disabled={isRedactActionDisabled({
                                                  isLocked: locked,
                                                  isFinalized: finalized,
                                                  isProcessing: this.state.redactionProcessing,
                                                  isXpenseInvoice:
                                                    this.state.invoice.type === 'XPENSE' ||
                                                    this.state.invoice.transaction_type === 'expense_invoice',
                                                })}
                                                className='btn btn-sm btn-secondary ml-2'
                                                onClick={() => {
                                                  this.setState({ showConfirmRedactProcess: true });
                                                }}
                                              >
                                                {this.props.data.t.read('redaction.redact')}
                                              </button>
                                            </Tooltip>
                                          )}
                                        </div>
                                        {(Utils.userHasRole(this.props.data, ['Admin', 'Manager']) ||
                                          AccessControl.hasActionAccess(this.props.data, 'canValidateInvoices')) && (
                                            <button
                                              disabled={this.state.validating || locked || finalized}
                                              className='btn btn-primary mx-auto'
                                              onClick={() => this.validateInvoice()}
                                            >
                                              {this.props.data.t.read('validate')}
                                              {this.state.validating && (
                                                <FontAwesomeIcon className='ml-2 text-secondary infinite-rotate faded' icon={faSync} />
                                              )}
                                            </button>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                  {this.canReturnInvoiceToApprover() && (
                                    <button
                                      disabled={locked || finalized || !this.hasPreviousInvoiceApprover()}
                                      title={!this.hasPreviousInvoiceApprover() ? this.props.data.t.read('return_to_approver_no_previous') : ''}
                                      className='btn btn-sm btn-secondary mr-2 text-nowrap'
                                      onClick={() => this.setState({ showReturnToApprover: true, returnToApproverComment: '' })}
                                    >
                                      {this.props.data.t.read('return_to_approver')}
                                    </button>
                                  )}
                                  {this.canReturnReportToEmployee() && (
                                    <button
                                      disabled={locked || finalized}
                                      className='btn btn-sm btn-secondary mr-2 text-nowrap'
                                      onClick={() => this.setState({ showReturnToEmployee: true, returnToEmployeeReason: '' })}
                                    >
                                      {this.props.data.t.read('return_to_employee.button')}
                                    </button>
                                  )}
                                  {Utils.userHasPageAccess(this.props.data, 'approval') &&
                                    (Utils.userHasRole(this.props.data, ['Admin', 'Manager', 'Clerk', 'Assistant']) ||
                                      AccessControl.hasActionAccess(this.props.data, 'canRequestApproval')) && (
                                      <button
                                        className='btn btn-sm btn-primary'
                                        onClick={() => this.setState({ showRequestApproval: true })}
                                        disabled={this.state.invoice.status === 'Validated' || finalized}
                                      >
                                        {this.props.data.t.read('approvals')}
                                      </button>
                                    )}
                                </div>
                              )}
                            {Utils.userHasPageAccess(this.props.data, 'approval') &&
                              (Utils.userHasRole(this.props.data, ['Admin', 'Approver']) ||
                                AccessControl.hasActionAccess(this.props.data, 'canApproveOrDeny')) && (() => {
                                const hideAction = !canDecideInvoice(this.state.invoice, this.props.data);
                                return (
                                  <div className='d-flex justify-content-around'>
                                    <button
                                      disabled={locked || finalized}
                                      className='btn  btn-primary'
                                      hidden={hideAction}
                                      onClick={() => this.approveInvoice()}
                                    >
                                      {this.props.data.t.read('approve')}
                                      {this.state.saving && <FontAwesomeIcon className='ml-2 text-secondary infinite-rotate faded' icon={faSync} />}
                                    </button>

                                    <button
                                      disabled={locked || finalized}
                                      className='btn btn-secondary'
                                      hidden={hideAction}
                                      onClick={() => this.setState({ showDelegation: true, delegatedApprover: null })}
                                    >
                                      {this.props.data.t.read('delegate')}
                                    </button>

                                    <button
                                      disabled={locked || finalized}
                                      className='btn btn-danger '
                                      hidden={hideAction}
                                      onClick={() => this.setState({ showDisapproval: true })}
                                    >
                                      {this.props.data.t.read('disapprove')}
                                    </button>
                                  </div>
                                );
                              })()}
                            </div>
                        )}
                      </div>
                    </div>
                  );
                  }}
                </LockWrapper>
              )}
              {!this.state.invoice && (
                <div className='loading-container'>
                  <FontAwesomeIcon className='infinite-rotate' icon={faSpinner} />
                </div>
              )}
            </>
          );
        }
      }
    )
  )
);
